import './styles.css';
export default () => (
  <svg
    id="freepik_stories-apartment-rent"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 750 500"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="freepik--background-complete--inject-89"
      className="animable"
      style={{transformOrigin: '366.8px 252.835px'}}>
      <polygon
        points="108.47 201.4 273.64 202.57 326.84 268.08 55.92 268.08 108.47 201.4"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '191.38px 234.74px',
        }}
        id="elay4jcgmdqxj"
        className="animable"
      />
      <g id="el5qm0ypyl3oj">
        <rect
          x="67.69"
          y="268.08"
          width="240.27"
          height="201.37"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '187.825px 368.765px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <polygon
        points="193.67 230.89 180.99 252.01 123.77 252.01 123.77 230.89 148.74 185.57 180.99 230.5 193.67 230.89"
        style={{
          fill: 'rgb(245, 245, 245)',
          transformOrigin: '158.72px 218.79px',
        }}
        id="el67f8n3aqxnp"
        className="animable"
      />
      <g id="elj8zev2wxeo">
        <rect
          x="46.77"
          y="398.36"
          width="9.15"
          height="71.09"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '51.345px 433.905px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="el6v1vu7gk6f7">
        <rect
          x="121.35"
          y="410.36"
          width="24.95"
          height="59.09"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '133.825px 439.905px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="el7tmxseu2yno">
        <circle
          cx="151.03"
          cy="222.93"
          r="9.33"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '151.03px 222.93px',
            transform: 'rotate(-45deg)',
          }}
          className="animable"
        />
      </g>
      <g id="elggbqpjceqf">
        <rect
          x="151.85"
          y="398.36"
          width="9.15"
          height="71.09"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '156.425px 433.905px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M124.07,443.18a1.29,1.29,0,1,0,1.29-1.29A1.29,1.29,0,0,0,124.07,443.18Z"
        style={{
          fill: 'rgb(250, 250, 250)',
          transformOrigin: '125.36px 443.18px',
        }}
        id="elzkbru7e1mp"
        className="animable"
      />
      <path
        d="M67.69,355.84c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,355.72,67.69,355.84Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 355.845px',
        }}
        id="eltdb1d4sqf48"
        className="animable"
      />
      <path
        d="M67.69,363c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,362.83,67.69,363Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 363.005px',
        }}
        id="el2e42bkokz66"
        className="animable"
      />
      <path
        d="M67.69,370.06c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,369.94,67.69,370.06Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 370.065px',
        }}
        id="el29rhohnr1kw"
        className="animable"
      />
      <path
        d="M67.69,377.17c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22S253.72,377,187.53,377,67.69,377.05,67.69,377.17Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 377.195px',
        }}
        id="elicm858zmnp"
        className="animable"
      />
      <path
        d="M67.69,384.28c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22-53.65-.23-119.84-.23S67.69,384.16,67.69,384.28Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 384.275px',
        }}
        id="el0nhguho78os"
        className="animable"
      />
      <path
        d="M67.69,391.39c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22-53.65-.23-119.84-.23S67.69,391.26,67.69,391.39Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 391.385px',
        }}
        id="el92lqremsjus"
        className="animable"
      />
      <path
        d="M67.69,398.5c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22-53.65-.23-119.84-.23S67.69,398.37,67.69,398.5Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 398.495px',
        }}
        id="elrw4zvon1ioh"
        className="animable"
      />
      <path
        d="M67.69,405.6c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,405.48,67.69,405.6Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '187.53px 405.605px',
        }}
        id="eld2pe7p6nvt"
        className="animable"
      />
      <g id="el3au0evp5d9t">
        <rect
          x="117.41"
          y="281.9"
          width="60.09"
          height="62.32"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '147.455px 313.06px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M117.41,344.22s0-.1,0-.3v-.86c0-.78,0-1.9,0-3.36,0-2.95,0-7.24,0-12.7,0-10.91.06-26.46.1-45.1l-.19.2,60.08,0h0l-.22-.23c0,22.87,0,44.27,0,62.32l.19-.19-43.52.1-12.22.05-3.23,0h0l3.19,0,12.18.05,43.64.1h.19v-.2c0-18.05,0-39.45,0-62.32v-.22h-.23l-60.08,0h-.2v.19c0,18.69.08,34.28.1,45.23,0,5.43,0,9.71,0,12.65,0,1.44,0,2.55,0,3.32,0,.36,0,.64,0,.84S117.41,344.22,117.41,344.22Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '147.345px 312.93px',
        }}
        id="elgj2bvden5o"
        className="animable"
      />
      <path
        d="M146.31,343.37c.12,0,.22-13.67.22-30.53s-.1-30.54-.22-30.54-.23,13.67-.23,30.54S146.18,343.37,146.31,343.37Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '146.305px 312.835px',
        }}
        id="el4u4bytdlxug"
        className="animable"
      />
      <path
        d="M118.07,315.06c0,.12,13.15.22,29.38.22s29.39-.1,29.39-.22-13.16-.22-29.39-.22S118.07,314.94,118.07,315.06Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '147.455px 315.06px',
        }}
        id="el8uu34sucw02"
        className="animable"
      />
      <g id="ele82i01zzt2">
        <rect
          x="82.91"
          y="295.26"
          width="18.55"
          height="36.35"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '92.185px 313.435px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M82.91,331.61a1.49,1.49,0,0,0,0-.19c0-.14,0-.31,0-.52,0-.49,0-1.17,0-2,0-1.78,0-4.34.06-7.54,0-6.45.06-15.5.1-26.07l-.21.21h18.54c.06,0-.42-.42-.22-.21h0v5.17c0,1.71,0,3.39,0,5.05,0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.16-.17-13.51.09-3.71.05h-1l-.34,0a1.64,1.64,0,0,0,.31,0l1,0,3.67,0,13.61.09h.17v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6,0-1.66,0-3.34,0-5.05v-5.17h0c.2.19-.27-.29-.23-.24l-18.54,0H82.7v.21c0,10.63.07,19.73.1,26.21,0,3.18,0,5.72.06,7.49,0,.85,0,1.51,0,2v.51C82.9,331.56,82.9,331.62,82.91,331.61Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '92.1449px 313.308px',
        }}
        id="elk3ejdwxts4"
        className="animable"
      />
      <path
        d="M92.12,331.59c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.22,8.18-.22,18.27S92,331.59,92.12,331.59Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '92.12px 313.32px',
        }}
        id="elppilq5zrhil"
        className="animable"
      />
      <path
        d="M83.12,314.7c0,.12,4.19.22,9.37.22s9.36-.1,9.36-.22-4.19-.23-9.36-.23S83.12,314.57,83.12,314.7Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '92.485px 314.695px',
        }}
        id="elgd9s0j0x1gk"
        className="animable"
      />
      <g id="ellb0x8zodvi">
        <rect
          x="194.44"
          y="295.26"
          width="18.55"
          height="36.35"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '203.715px 313.435px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M194.44,331.61a1.49,1.49,0,0,0,0-.19c0-.14,0-.31,0-.52,0-.49,0-1.17,0-2,0-1.78,0-4.34.06-7.54,0-6.45.06-15.5.1-26.07l-.21.21H213c.06,0-.42-.42-.22-.21h0v5.17c0,1.71,0,3.39,0,5.05,0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.17-.17-13.52.09-3.71.05h-1l-.34,0a1.64,1.64,0,0,0,.31,0l.95,0,3.67,0,13.62.09h.16v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6V295.28h0c.2.19-.27-.29-.23-.24l-18.54,0h-.21v.21c0,10.63.07,19.73.1,26.21,0,3.18,0,5.72.06,7.49,0,.85,0,1.51,0,2,0,.21,0,.38,0,.51S194.43,331.62,194.44,331.61Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '203.625px 313.358px',
        }}
        id="eljpwikmq98"
        className="animable"
      />
      <path
        d="M203.65,331.59c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.22,8.18-.22,18.27S203.53,331.59,203.65,331.59Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '203.65px 313.32px',
        }}
        id="elz3jbiv9zu37"
        className="animable"
      />
      <path
        d="M194.65,314.7c0,.12,4.19.22,9.37.22s9.36-.1,9.36-.22-4.19-.23-9.36-.23S194.65,314.57,194.65,314.7Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '204.015px 314.695px',
        }}
        id="el3pkciucp9fo"
        className="animable"
      />
      <g id="el11m1k2mhcqlh">
        <rect
          x="168.29"
          y="411.87"
          width="18.55"
          height="36.35"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '177.565px 430.045px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M168.29,448.22a1.49,1.49,0,0,0,0-.19c0-.14,0-.31,0-.53,0-.48,0-1.16,0-2,0-1.79,0-4.34.06-7.54,0-6.45.06-15.5.1-26.07l-.21.21h18.54l-.22-.22v5.19c0,1.71,0,3.39,0,5.05,0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.16-.17-13.51.09-3.71,0-1,0a2.3,2.3,0,0,0-.34,0,1.64,1.64,0,0,0,.31,0l1,0,3.67,0,13.61.09H187v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6,0-1.66,0-3.34,0-5.05v-5.19l-.23-.23-18.54,0h-.21v.21c0,10.62.07,19.73.1,26.21,0,3.18,0,5.72.06,7.49,0,.85,0,1.51,0,2,0,.21,0,.37,0,.51S168.28,448.22,168.29,448.22Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '177.51px 429.865px',
        }}
        id="elchi1awjrhgm"
        className="animable"
      />
      <path
        d="M177.5,448.2c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.22,8.18-.22,18.27S177.38,448.2,177.5,448.2Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '177.5px 429.93px',
        }}
        id="elrzgxd7opbgo"
        className="animable"
      />
      <path
        d="M168.5,431.31c0,.12,4.19.22,9.37.22s9.36-.1,9.36-.22-4.19-.23-9.36-.23S168.5,431.18,168.5,431.31Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '177.865px 431.305px',
        }}
        id="elc5qz10ehros"
        className="animable"
      />
      <g id="elkn0kb1jclme">
        <rect
          x="88.57"
          y="411.87"
          width="18.55"
          height="36.35"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '97.845px 430.045px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M88.57,448.22a.76.76,0,0,0,0-.19c0-.14,0-.31,0-.53l0-2c0-1.79,0-4.34.05-7.54,0-6.45.06-15.5.1-26.07l-.21.21h18.55l-.22-.22v10.24c0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.17-.17-13.51.09-3.71,0-1,0-.35,0,.32,0,.94,0,3.68,0,13.61.09h.17v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6v-5.05c0-.86,0-1.72,0-2.58v-2.61l-.23-.23-18.55,0h-.21v.21c0,10.62.08,19.73.11,26.21,0,3.18,0,5.72,0,7.49l0,2v.51C88.57,448.17,88.57,448.22,88.57,448.22Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '97.665px 429.865px',
        }}
        id="el5o4u6o4v0fr"
        className="animable"
      />
      <path
        d="M97.79,448.2c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.23,8.18-.23,18.27S97.66,448.2,97.79,448.2Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '97.785px 429.93px',
        }}
        id="elqr5oa13ju8"
        className="animable"
      />
      <path
        d="M88.79,431.31c0,.12,4.19.22,9.36.22s9.37-.1,9.37-.22-4.19-.23-9.37-.23S88.79,431.18,88.79,431.31Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '98.155px 431.305px',
        }}
        id="eledpqjo2zvt5"
        className="animable"
      />
      <path
        d="M232.58,469.45c.13,0,.23-16.53.23-36.93s-.1-36.92-.23-36.92-.22,16.53-.22,36.92S232.46,469.45,232.58,469.45Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '232.585px 432.525px',
        }}
        id="elr4o38sx844b"
        className="animable"
      />
      <path
        d="M220.66,343.37a3.54,3.54,0,0,0,0-.5c0-.37,0-.82,0-1.39,0-1.24.05-2.94.08-5l-.15.15c4.62,0,11.27.07,18.65.07l-.22-.22h0V340c0,1.16,0,2.29,0,3.37l.21-.21c-5.34,0-10,.06-13.3.1l-3.9.06-1.07,0-.38,0a1.2,1.2,0,0,0,.33,0l1,0,3.86.06c3.31,0,8,.09,13.44.1h.22v-.22c0-1.08,0-2.21,0-3.37v-3.54h0l-.23-.23c-7.38,0-14,0-18.65.07h-.16v.15c0,2.13.06,3.87.08,5.13,0,.55,0,1,0,1.36A2.23,2.23,0,0,0,220.66,343.37Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '229.91px 339.8px',
        }}
        id="elkko7awr1c5"
        className="animable"
      />
      <path
        d="M104,288.1a4.37,4.37,0,0,0,0-.48c0-.35,0-.78,0-1.3,0-1.17,0-2.74.09-4.65l-.17.16,13.45.06-.22-.22h0v1.66c0,.55,0,1.1,0,1.63v3.12l.22-.22c-3.88,0-7.21.07-9.6.11L105,288a8,8,0,0,0-1,.06,9.21,9.21,0,0,0,1,0l2.77.06c2.37,0,5.77.08,9.74.1h.21v-.21c0-1,0-2,0-3.12v-3.29h0l-.23-.23L104,281.5h-.17v.16c0,1.95.06,3.55.09,4.75l0,1.26A2,2,0,0,0,104,288.1Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '110.775px 284.795px',
        }}
        id="el3zdt1s2sroe"
        className="animable"
      />
      <g id="elrutgwkhv5rk">
        <rect
          x="208.73"
          y="343.37"
          width="18.05"
          height="6.59"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '217.755px 346.665px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="el309f0e2vm07">
        <rect
          x="186.57"
          y="288.48"
          width="18.05"
          height="6.59"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '195.595px 291.775px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="elo79zvcnmzpd">
        <rect
          x="99.45"
          y="337.38"
          width="18.05"
          height="6.59"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '108.475px 340.675px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="el8yhti6zj0c8">
        <rect
          x="67.69"
          y="313.06"
          width="15.03"
          height="6.59"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '75.205px 316.355px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <polygon
        points="232.58 398.72 34.78 398.72 77.82 363.18 184.87 363.18 232.58 398.72"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '133.68px 380.95px',
        }}
        id="eljbi828ihnzg"
        className="animable"
      />
      <polygon
        points="193.67 230.89 204.02 230.89 168.19 181.12 145.56 181.36 180.99 230.5 193.67 230.89"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '174.79px 206.005px',
        }}
        id="el1m7u1obqrmb"
        className="animable"
      />
      <polyline
        points="123.77 230.89 116.86 230.89 145.56 181.36 148.74 185.57 123.77 230.89"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '132.8px 206.125px',
        }}
        id="ele1zzt6vob6i"
        className="animable"
      />
      <polygon
        points="180.99 252.01 180.99 230.53 193.67 230.53 180.99 252.01"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '187.33px 241.27px',
        }}
        id="el0st0lb3ywdh"
        className="animable"
      />
      <polygon
        points="184.87 363.18 147.41 398.72 232.86 398.72 184.87 363.18"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '190.135px 380.95px',
        }}
        id="el1ss9s57pqeq"
        className="animable"
      />
      <g id="ell1kow2u0xnq">
        <rect
          x="460.88"
          y="74.93"
          width="124.41"
          height="394.29"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '523.085px 272.075px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="elbvcy1kst6ce">
        <rect
          x="460.88"
          y="74.93"
          width="62.21"
          height="393.2"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '491.985px 271.53px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="elouu9i30lkmp">
        <rect
          x="527.15"
          y="36.22"
          width="43.93"
          height="38.71"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '549.115px 55.575px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="el65bwoqof5q">
        <rect
          x="527.15"
          y="36.22"
          width="10.47"
          height="38.71"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '532.385px 55.575px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <polyline
        points="595.66 74.93 595.66 72.67 457.24 72.67 457.24 74.93"
        style={{fill: 'rgb(224, 224, 224)', transformOrigin: '526.45px 73.8px'}}
        id="el6o5ls6ucu5y"
        className="animable"
      />
      <g id="eld00jdoke2w">
        <rect
          x="550.2"
          y="91.81"
          width="10.53"
          height="22.2"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '555.465px 102.91px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M523.09,122.73c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,122.49,523.09,122.73Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '554.19px 122.725px',
        }}
        id="elzgwelcnjli"
        className="animable"
      />
      <g id="elujrgg67sqmm">
        <rect
          x="487.46"
          y="91.81"
          width="10.53"
          height="22.2"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.725px 102.91px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M460.34,122.73c0,.23,13.93.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S460.34,122.49,460.34,122.73Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '491.44px 122.725px',
        }}
        id="elqwusbnljnqk"
        className="animable"
      />
      <g id="elzbr4hbj3eh">
        <rect
          x="487.46"
          y="135.89"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.725px 146.995px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M460.34,166.81c0,.24,13.93.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S460.34,166.58,460.34,166.81Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '491.44px 166.815px',
        }}
        id="elqcuzz5o0dy"
        className="animable"
      />
      <g id="elhowk11y3oae">
        <rect
          x="487.46"
          y="181.31"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.725px 192.415px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M460.34,212.23c0,.24,13.93.42,31.1.42s31.1-.18,31.1-.42-13.92-.42-31.1-.42S460.34,212,460.34,212.23Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '491.44px 212.23px',
        }}
        id="eluvtum579zll"
        className="animable"
      />
      <g id="el8gvg5v954nm">
        <rect
          x="487.46"
          y="226.73"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.725px 237.835px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M460.34,257.65c0,.23,13.93.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S460.34,257.41,460.34,257.65Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '491.44px 257.645px',
        }}
        id="eliir5ahuu5f"
        className="animable"
      />
      <g id="elep5f8qblclm">
        <rect
          x="487.46"
          y="270.84"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.725px 281.945px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M460.34,301.76c0,.24,13.93.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S460.34,301.53,460.34,301.76Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '491.44px 301.765px',
        }}
        id="elgd4k2fn1etf"
        className="animable"
      />
      <g id="el8mpnsy3etkk">
        <rect
          x="487.46"
          y="315.14"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.725px 326.245px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="el7fi4przattd">
        <rect
          x="487.46"
          y="360.02"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.725px 371.125px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M460.34,346.06c0,.23,13.93.42,31.1.42s31.1-.19,31.1-.42-13.92-.42-31.1-.42S460.34,345.83,460.34,346.06Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '491.44px 346.06px',
        }}
        id="elnwi8yal9s9"
        className="animable"
      />
      <g id="elirr7zobnnp">
        <rect
          x="550.2"
          y="136.57"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '555.465px 147.675px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M523.09,167.49c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,167.25,523.09,167.49Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '554.19px 167.485px',
        }}
        id="elqsyvu4foq7"
        className="animable"
      />
      <g id="elkyn50p78s0e">
        <rect
          x="550.2"
          y="181.33"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '555.465px 192.435px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M523.09,212.25c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,212,523.09,212.25Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '554.19px 212.245px',
        }}
        id="elczr5tniv0br"
        className="animable"
      />
      <g id="el0lybg771w1pf">
        <rect
          x="550.2"
          y="226.09"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '555.465px 237.195px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M523.09,257c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,256.77,523.09,257Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '554.19px 256.995px',
        }}
        id="elnyrbwpzep1f"
        className="animable"
      />
      <g id="elwjsqphvdic">
        <rect
          x="550.2"
          y="270.84"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '555.465px 281.945px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M523.09,301.76c0,.24,13.92.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S523.09,301.53,523.09,301.76Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '554.19px 301.765px',
        }}
        id="el3n208fnblh1"
        className="animable"
      />
      <g id="ell9y6oy3utyc">
        <rect
          x="550.2"
          y="315.6"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '555.465px 326.705px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M523.09,346.52c0,.24,13.92.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S523.09,346.29,523.09,346.52Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '554.19px 346.525px',
        }}
        id="el0ac70sxqghcg"
        className="animable"
      />
      <g id="el5zws5hqm3og">
        <rect
          x="550.2"
          y="360.36"
          width="10.53"
          height="22.21"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '555.465px 371.465px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <polygon
        points="542.43 469.21 686.21 469.21 686.84 241.98 543.06 241.98 542.43 469.21"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '614.635px 355.595px',
        }}
        id="el5xa3ykzwtz2"
        className="animable"
      />
      <g id="elc9tiaefpfy4">
        <rect
          x="543.06"
          y="241.98"
          width="71.89"
          height="227.23"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '579.005px 355.595px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="el9wivl5xy91b">
        <rect
          x="619.65"
          y="197.25"
          width="50.77"
          height="44.73"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '645.035px 219.615px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="eldga7r3fqv1">
        <rect
          x="619.65"
          y="197.25"
          width="12.1"
          height="44.73"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '625.7px 219.615px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="elwap65bbvl9k">
        <rect
          x="538.85"
          y="239.37"
          width="159.97"
          height="2.61"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '618.835px 240.675px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <g id="eloa2qvoa76d9">
        <rect
          x="646.29"
          y="261.49"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '652.375px 274.32px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M615,297.23c0,.27,16.09.48,35.94.48s36-.21,36-.48-16.09-.49-36-.49S615,297,615,297.23Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '650.97px 297.225px',
        }}
        id="elm9189g7rruf"
        className="animable"
      />
      <g id="elfszkrb4bkdl">
        <rect
          x="573.77"
          y="261.49"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '579.855px 274.32px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M542.43,297.23c0,.27,16.1.48,36,.48s35.94-.21,35.94-.48-16.09-.49-35.94-.49S542.43,297,542.43,297.23Z"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '578.4px 297.225px',
        }}
        id="el00z2erijrnvd9"
        className="animable"
      />
      <g id="elh9bj0cwi2jo">
        <rect
          x="573.77"
          y="312.44"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '579.855px 325.27px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M542.43,348.17c0,.27,16.1.49,36,.49s35.94-.22,35.94-.49-16.09-.49-35.94-.49S542.43,347.9,542.43,348.17Z"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '578.4px 348.17px',
        }}
        id="elx70u47mnz1"
        className="animable"
      />
      <g id="elsi9a6k1caa">
        <rect
          x="573.77"
          y="364.93"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '579.855px 377.76px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M542.43,400.66c0,.27,16.1.49,36,.49s35.94-.22,35.94-.49-16.09-.49-35.94-.49S542.43,400.39,542.43,400.66Z"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '578.4px 400.66px',
        }}
        id="elx9ee14eark"
        className="animable"
      />
      <g id="elxxrqnxuyp2">
        <rect
          x="573.77"
          y="417.41"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '579.855px 430.24px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M542.43,453.15c0,.27,16.1.49,36,.49s35.94-.22,35.94-.49-16.09-.49-35.94-.49S542.43,452.88,542.43,453.15Z"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '578.4px 453.15px',
        }}
        id="el2ehs8nzr3ft"
        className="animable"
      />
      <g id="elzh9j1amwox">
        <rect
          x="646.29"
          y="313.22"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '652.375px 326.05px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M615,349c0,.27,16.09.49,35.94.49s36-.22,36-.49-16.09-.49-36-.49S615,348.68,615,349Z"
        style={{fill: 'rgb(224, 224, 224)', transformOrigin: '650.97px 349px'}}
        id="elunzqkwm99a"
        className="animable"
      />
      <g id="el4n3r8qmoi5">
        <rect
          x="646.29"
          y="364.95"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '652.375px 377.78px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M615,400.68c0,.27,16.09.49,35.94.49s36-.22,36-.49-16.09-.49-36-.49S615,400.41,615,400.68Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '650.97px 400.68px',
        }}
        id="elf8v0bs3efl6"
        className="animable"
      />
      <g id="el5pdkonz2qir">
        <rect
          x="646.29"
          y="416.67"
          width="12.17"
          height="25.66"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '652.375px 429.5px',
            transform: 'rotate(180deg)',
          }}
          className="animable"
        />
      </g>
      <path
        d="M615,452.41c0,.27,16.09.49,35.94.49s36-.22,36-.49-16.09-.49-36-.49S615,452.14,615,452.41Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '650.97px 452.41px',
        }}
        id="el1xml17dqpye"
        className="animable"
      />
    </g>
    <g
      id="freepik--Plant--inject-89"
      className="animable"
      style={{transformOrigin: '592.341px 441.031px'}}>
      <path
        d="M592.34,412.66a10.62,10.62,0,0,1,5.5,6.24,18.56,18.56,0,0,1,.73,8.45c-.62,5.48-3.73,11-7.09,15.4-4.61-4-5.68-11.06-6-14.66-.5-5.69,2.06-16.28,6.85-15.43"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '592.091px 427.681px',
        }}
        id="eldb9h8zjkqr4"
        className="animable"
      />
      <path
        d="M596.85,451.8a9.06,9.06,0,0,1,2.93-8.62,12.05,12.05,0,0,1,8.88-2.78,5.11,5.11,0,0,1,3.9,1.75,3.91,3.91,0,0,1,.06,3.93,7.93,7.93,0,0,1-2.91,2.87c-4,2.51-8.34,4.2-12.86,2.85"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '604.896px 446.313px',
        }}
        id="el0a80emfaok4l"
        className="animable"
      />
      <path
        d="M590.93,468.61a5.72,5.72,0,0,1,.16-1.13c.15-.79.34-1.81.56-3a32,32,0,0,1,3.14-9.73,19.56,19.56,0,0,1,7-7.42,13.59,13.59,0,0,1,2.84-1.26c.35-.11.63-.16.82-.21a.92.92,0,0,1,.29,0,21.54,21.54,0,0,0-3.81,1.75,20.13,20.13,0,0,0-6.78,7.37,34.58,34.58,0,0,0-3.21,9.59c-.28,1.28-.51,2.31-.68,3A6.26,6.26,0,0,1,590.93,468.61Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '598.335px 457.229px',
        }}
        id="elao4bap06be"
        className="animable"
      />
      <path
        d="M591.1,420.89a1.61,1.61,0,0,1,.06.49c0,.37.05.84.08,1.42.07,1.23.14,3,.21,5.2.14,4.39.26,10.47.23,17.17s-.2,12.78-.38,17.18c-.09,2.19-.17,4-.25,5.2,0,.57-.07,1-.1,1.41a1.61,1.61,0,0,1-.06.49,2.73,2.73,0,0,1,0-.5c0-.36,0-.83,0-1.41,0-1.28.08-3,.13-5.2.11-4.4.23-10.46.26-17.17s0-12.77-.11-17.16c0-2.16-.06-3.93-.08-5.21,0-.58,0-1.05,0-1.41A2.73,2.73,0,0,1,591.1,420.89Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '591.282px 445.17px'}}
        id="eldj8atxl6kk4"
        className="animable"
      />
      <path
        d="M588.86,455.13a21.2,21.2,0,0,0-11.58-15.53c-1.54-.74-3.55-1.22-4.82-.07s-1,3.21-.37,4.8a18.1,18.1,0,0,0,16.66,11.25"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '580.211px 447.211px',
        }}
        id="el0vs9hvveyw6"
        className="animable"
      />
      <path
        d="M578,444.8a6.13,6.13,0,0,1,1,.43,9.62,9.62,0,0,1,1.11.59c.41.26.91.51,1.41.88s1.06.74,1.61,1.22a21.47,21.47,0,0,1,1.72,1.55,24.61,24.61,0,0,1,3.26,4.19,22.91,22.91,0,0,1,2.14,4.86,20,20,0,0,1,.55,2.26,17.59,17.59,0,0,1,.27,2,14.32,14.32,0,0,1,.08,1.66,9.45,9.45,0,0,1,0,1.25,6.78,6.78,0,0,1-.11,1.06c-.1,0,.06-1.52-.21-3.94a17.83,17.83,0,0,0-.32-2,19,19,0,0,0-.57-2.21,23.83,23.83,0,0,0-2.14-4.76,24.28,24.28,0,0,0-3.18-4.14c-.57-.57-1.11-1.11-1.66-1.56a19.21,19.21,0,0,0-1.57-1.24C579.38,445.51,578,444.88,578,444.8Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '584.585px 455.775px',
        }}
        id="elcg7o7qodvwp"
        className="animable"
      />
    </g>
    <g
      id="freepik--Device--inject-89"
      className="animable"
      style={{transformOrigin: '363.96px 257.765px'}}>
      <path
        d="M436,470.07,291.77,470a31.43,31.43,0,0,1-31.41-31.44l.07-361.68a31.44,31.44,0,0,1,31.45-31.42l144.27.08A31.43,31.43,0,0,1,467.56,77l-.07,361.69A31.44,31.44,0,0,1,436,470.07Z"
        style={{
          fill: 'rgb(69, 90, 100)',
          transformOrigin: '363.96px 257.765px',
        }}
        id="ele9iovec0fsd"
        className="animable"
      />
      <path
        d="M437.2,58.28h-28a6.94,6.94,0,0,0-6.79,7.09v5.08a6.94,6.94,0,0,1-6.79,7.09l-54.53,0a7,7,0,0,1-6.79-7.1V65.32a6.94,6.94,0,0,0-6.79-7.1H293.21a22,22,0,0,0-22,22l-.07,353a22,22,0,0,0,22,22l144,.09a22,22,0,0,0,22-22l.07-353A22,22,0,0,0,437.2,58.28Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '365.175px 256.765px',
        }}
        id="el1f4arlbps4a"
        className="animable"
      />
      <path
        d="M437.2,58.28l.75,0a14.37,14.37,0,0,1,2.23.17,20.71,20.71,0,0,1,8.26,2.85,21.18,21.18,0,0,1,5,4.07A21.74,21.74,0,0,1,457.65,72a22.79,22.79,0,0,1,1.65,8.94c0,3.25,0,6.71,0,10.37,0,29.33,0,71.76.08,124.18s0,114.86,0,184.18v33a23.5,23.5,0,0,1-.85,6.71,22.15,22.15,0,0,1-2.81,6.21,23.78,23.78,0,0,1-4.58,5.08,22.25,22.25,0,0,1-12.71,4.94c-4.62.13-9.2,0-13.84.06h-28l-57.52,0-29.43,0H294.79a23.18,23.18,0,0,1-14.33-4,22.49,22.49,0,0,1-8.73-12.05,24.39,24.39,0,0,1-.92-7.44v-7.42q0-14.82,0-29.43,0-29.24,0-57.55c0-37.72,0-74.11,0-108.78s0-67.6,0-98.43q0-23.11,0-44.61V80.55c0-.89.08-1.78.13-2.67s.22-1.77.45-2.62a22.46,22.46,0,0,1,4.63-9.33,22.33,22.33,0,0,1,17.95-8l19.18,0H327a7,7,0,0,1,4.34,1.21,7.28,7.28,0,0,1,2.69,3.53,12,12,0,0,1,.45,4.35c0,.72,0,1.43,0,2.14a18,18,0,0,0,.07,2.1A7,7,0,0,0,336.23,75a6.48,6.48,0,0,0,3.36,2.09,7.7,7.7,0,0,0,2,.19h10l29,0,12.79,0c1,0,2,0,3,0a6.42,6.42,0,0,0,2.7-1A7,7,0,0,0,402.14,72a12,12,0,0,0,.17-2.67c0-.89,0-1.77,0-2.64a15.58,15.58,0,0,1,.11-2.56,7.62,7.62,0,0,1,.83-2.36,7,7,0,0,1,3.52-3.11,10.81,10.81,0,0,1,4.37-.46l14.28,0,8.77,0,3,0-3,0-8.77,0-14.28,0a10.7,10.7,0,0,0-4.3.47,6.73,6.73,0,0,0-3.4,3,7.25,7.25,0,0,0-.8,2.29,14.1,14.1,0,0,0-.1,2.53v2.64a13.26,13.26,0,0,1-.17,2.72,7.21,7.21,0,0,1-3.19,4.6,6.81,6.81,0,0,1-2.8,1c-1,.09-2,0-3,0H341.57a7.7,7.7,0,0,1-2.07-.2,6.85,6.85,0,0,1-3.56-2.2,7.28,7.28,0,0,1-1.73-3.88,17.24,17.24,0,0,1-.08-2.15V67.11a11.42,11.42,0,0,0-.43-4.21,6.82,6.82,0,0,0-2.55-3.35A6.7,6.7,0,0,0,327,58.42H294.11a21.86,21.86,0,0,0-17.6,7.81A22,22,0,0,0,272,75.36c-.22.84-.29,1.71-.44,2.57s-.11,1.74-.12,2.62v5.34q0,21.47,0,44.61c0,30.83,0,63.77,0,98.43V337.71q0,28.31,0,57.55v29.43c0,2.47,0,4.94,0,7.42a23.75,23.75,0,0,0,.9,7.27,21.88,21.88,0,0,0,8.48,11.71,22.58,22.58,0,0,0,14,3.85h14.86l29.43,0,57.52,0,28,0c4.62,0,9.26.07,13.8-.06a21.62,21.62,0,0,0,12.37-4.8,23.37,23.37,0,0,0,4.47-4.95,21.81,21.81,0,0,0,2.74-6,23.31,23.31,0,0,0,.82-6.55V426q0-13.31,0-26.31c0-69.32.08-131.74.11-184.18s.09-94.85.12-124.18q0-5.49,0-10.37A22.8,22.8,0,0,0,457.48,72a21.93,21.93,0,0,0-4.14-6.54,21,21,0,0,0-5-4.06,20.77,20.77,0,0,0-8.2-2.9,18.49,18.49,0,0,0-2.22-.2Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '365.107px 256.81px'}}
        id="el9i2knfan4kb"
        className="animable"
      />
      <path
        d="M441.42,98.52c0,.09-3.64.2-8.13.23s-8.12,0-8.12-.1,3.63-.2,8.12-.24S441.42,98.42,441.42,98.52Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '433.295px 98.5786px',
        }}
        id="elp740y397ks"
        className="animable"
      />
      <path
        d="M441.45,102.67c0,.1-3.64.21-8.12.24s-8.13,0-8.13-.1,3.64-.2,8.12-.24S441.45,102.58,441.45,102.67Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '433.325px 102.739px',
        }}
        id="elb7eq0ulqei"
        className="animable"
      />
      <path
        d="M441.49,106.83c0,.1-3.64.2-8.13.24s-8.12,0-8.12-.1,3.63-.21,8.12-.24S441.48,106.74,441.49,106.83Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '433.365px 106.903px',
        }}
        id="elywl1l7d5jt"
        className="animable"
      />
      <path
        d="M293.39,108.12l.34,0,.94,0,3.47-.09-.09.1c0-.77,0-1.61-.05-2.52,0-.46,0-.9,0-1.44a1.32,1.32,0,0,1,1.16-1.07c.56,0,1.06,0,1.66,0a1.34,1.34,0,0,1,1.14,1.34c0,1.17,0,2.4,0,3.67l-.16-.16,4.38,0-.17.16c0-1.76,0-3.58-.05-5.45,0-.47,0-.93,0-1.39a1.4,1.4,0,0,0-.61-1l-1.92-1.89-1.84-1.82-.9-.88c-.31-.3-.55-.61-.9-.68a1.2,1.2,0,0,0-1,.19c-.26.23-.55.54-.81.8l-1.57,1.59c-1,1-2,2-2.77,2.85a3.12,3.12,0,0,0-.22,1.63v1.54c0,1,0,1.78,0,2.49s0,1.16,0,1.59a4.66,4.66,0,0,1,0,.57l0-.53c0-.42,0-.94,0-1.56s0-1.55-.06-2.51c0-.49,0-1,0-1.57,0-.28,0-.56,0-.86a1.85,1.85,0,0,1,.24-.91c.81-1,1.78-1.88,2.77-2.93l1.56-1.6c.28-.27.51-.55.85-.83a1.47,1.47,0,0,1,1.27-.25,2.33,2.33,0,0,1,1,.75l.9.88L303.71,98l1.91,1.88a4.21,4.21,0,0,1,.49.53,1.32,1.32,0,0,1,.23.74c0,.46,0,.93,0,1.4,0,1.87,0,3.69,0,5.45v.17h-.17l-4.38,0h-.16v-.16c0-1.27,0-2.5,0-3.67a1.05,1.05,0,0,0-.88-1.06c-.5,0-1.1,0-1.59,0a1.07,1.07,0,0,0-.94.85c0,.44,0,1,0,1.4v2.62h-.1l-3.52,0h-.92Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '299.85px 101.45px'}}
        id="elyhplp2za4hq"
        className="animable"
      />
      <rect
        x="289.88"
        y="205.14"
        width="61.88"
        height="55.83"
        rx="2.55"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '320.82px 233.055px',
        }}
        id="elzvcxlt7q6zi"
        className="animable"
      />
      <polygon
        points="409.28 211.56 409.73 212.49 410.75 212.63 410.01 213.35 410.19 214.36 409.28 213.88 408.37 214.36 408.54 213.35 407.81 212.63 408.82 212.49 409.28 211.56"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '409.28px 212.96px',
        }}
        id="el2itddb67aha"
        className="animable"
      />
      <polygon
        points="413.24 211.56 413.69 212.49 414.71 212.63 413.97 213.35 414.15 214.36 413.24 213.88 412.33 214.36 412.5 213.35 411.77 212.63 412.78 212.49 413.24 211.56"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '413.24px 212.96px',
        }}
        id="el4i1v1ca626x"
        className="animable"
      />
      <polygon
        points="417.2 211.56 417.65 212.49 418.67 212.63 417.93 213.35 418.11 214.36 417.2 213.88 416.29 214.36 416.46 213.35 415.73 212.63 416.74 212.49 417.2 211.56"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '417.2px 212.96px',
        }}
        id="eliq4tqpvq5so"
        className="animable"
      />
      <polygon
        points="421.16 211.56 421.61 212.49 422.63 212.63 421.89 213.35 422.07 214.36 421.16 213.88 420.25 214.36 420.42 213.35 419.69 212.63 420.7 212.49 421.16 211.56"
        style={{
          fill: 'rgb(245, 245, 245)',
          transformOrigin: '421.16px 212.96px',
        }}
        id="eln5u31j5gqhq"
        className="animable"
      />
      <polygon
        points="425.12 211.56 425.57 212.49 426.59 212.63 425.85 213.35 426.03 214.36 425.12 213.88 424.21 214.36 424.38 213.35 423.65 212.63 424.67 212.49 425.12 211.56"
        style={{
          fill: 'rgb(245, 245, 245)',
          transformOrigin: '425.12px 212.96px',
        }}
        id="ela3lg5p2kfrc"
        className="animable"
      />
      <path
        d="M408.84,221.48c0,.15-9.59.26-21.42.26s-21.41-.11-21.41-.26,9.58-.26,21.41-.26S408.84,221.34,408.84,221.48Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '387.425px 221.48px',
        }}
        id="el0o63b5hvto6"
        className="animable"
      />
      <path
        d="M442.58,228.75c0,.14-17.34.26-38.73.26s-38.74-.12-38.74-.26,17.34-.26,38.74-.26S442.58,228.61,442.58,228.75Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '403.845px 228.75px'}}
        id="el2p51gdkxwgq"
        className="animable"
      />
      <path
        d="M403.91,236.19c0,.14-8.52.26-19,.26s-19-.12-19-.26,8.52-.26,19-.26S403.91,236,403.91,236.19Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '384.91px 236.19px'}}
        id="elnpqlhewopbb"
        className="animable"
      />
      <path
        d="M395.6,258.52H372a5.49,5.49,0,0,1-5.49-5.5h0a5.49,5.49,0,0,1,5.49-5.49H395.6a5.49,5.49,0,0,1,5.49,5.49h0A5.49,5.49,0,0,1,395.6,258.52Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '383.8px 253.025px',
        }}
        id="elkt0ehd90o6d"
        className="animable"
      />
      <path
        d="M328.75,251a5.4,5.4,0,0,1,0-.63c0-.43,0-1,0-1.76,0-1.57,0-3.79-.06-6.58,0-5.64-.07-13.57-.12-22.9l.24.23-21.49,0,.26-.26h0V228c0,2.87,0,5.65,0,8.34,0,5.36,0,10.33,0,14.73l-.21-.21,15.59.11,4.34,0,1.15,0,.41,0a1.27,1.27,0,0,1-.36,0l-1.11,0-4.3,0-15.72.11h-.21V251c0-4.4,0-9.37,0-14.73,0-2.69,0-5.47,0-8.34v-8.79h0l.26-.26,21.49,0H329v.24c-.05,9.39-.09,17.38-.12,23.06,0,2.76-.05,5-.06,6.52,0,.72,0,1.29,0,1.72A3.92,3.92,0,0,1,328.75,251Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '318.08px 234.98px',
        }}
        id="el8wnhb5aeb0g"
        className="animable"
      />
      <path
        d="M324.53,214.92a28.65,28.65,0,0,1,.24,4.24v.23h-.25l-2.84,0-.26-.26h0v-.58c0-.19,0-.38,0-.57,0-.38,0-.75,0-1.11l0-2v-.21h.2a15.49,15.49,0,0,1,2.84.21,21.23,21.23,0,0,1-2.84.21l.21-.21c0,.62,0,1.28,0,2,0,.36,0,.73,0,1.11v1.15h0c.24.23-.31-.32-.26-.26l2.84,0-.23.24A37.57,37.57,0,0,1,324.53,214.92Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '323.097px 217.024px',
        }}
        id="el4afj9xvmcwc"
        className="animable"
      />
      <path
        d="M336.78,251.2a2.61,2.61,0,0,1-.51,0h-1.55l-6,0h-.15V251c-.07-7.17-.11-18.78-.11-31.87v-.26H337v.26c-.05,9.14-.09,17.17-.12,23,0,2.81-.05,5.08-.07,6.7,0,.74,0,1.33,0,1.78a4.17,4.17,0,0,1,0,.6,6.13,6.13,0,0,1,0-.66c0-.47,0-1.07,0-1.84,0-1.63-.05-3.92-.08-6.76,0-5.75-.07-13.71-.11-22.78l.25.25h-8l.26-.26c0,13.09,0,24.7-.1,31.87l-.15-.16,5.87.21,1.58.08A3.37,3.37,0,0,1,336.78,251.2Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '332.73px 235.041px',
        }}
        id="elftwe3oesrsh"
        className="animable"
      />
      <rect
        x="310.69"
        y="223.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '312.355px 224.815px',
        }}
        id="elfgaaxxet59u"
        className="animable"
      />
      <rect
        x="316.34"
        y="223.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '318.005px 224.815px',
        }}
        id="elk0647hbhdrh"
        className="animable"
      />
      <rect
        x="321.99"
        y="223.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '323.655px 224.815px',
        }}
        id="elp8brl8zr23q"
        className="animable"
      />
      <rect
        x="310.69"
        y="228.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '312.355px 230.545px',
        }}
        id="elbbsccyhonm5"
        className="animable"
      />
      <rect
        x="316.34"
        y="228.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '318.005px 230.545px',
        }}
        id="el4ac3lfwle2"
        className="animable"
      />
      <rect
        x="321.99"
        y="228.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '323.655px 230.545px',
        }}
        id="elewan5d9v3m"
        className="animable"
      />
      <rect
        x="310.69"
        y="234.61"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '312.355px 236.275px',
        }}
        id="el55s30wewvbf"
        className="animable"
      />
      <rect
        x="316.34"
        y="234.61"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '318.005px 236.275px',
        }}
        id="elv6i9438htne"
        className="animable"
      />
      <rect
        x="321.99"
        y="234.61"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '323.655px 236.275px',
        }}
        id="el3gyyneohsq5"
        className="animable"
      />
      <rect
        x="310.69"
        y="240.34"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '312.355px 242.005px',
        }}
        id="eliozkks9datk"
        className="animable"
      />
      <rect
        x="316.34"
        y="240.34"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '318.005px 242.005px',
        }}
        id="eljshpa6c3z6"
        className="animable"
      />
      <rect
        x="321.99"
        y="240.34"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '323.655px 242.005px',
        }}
        id="elylmvz9zjzu"
        className="animable"
      />
      <rect
        x="330.82"
        y="223.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '332.485px 224.815px',
        }}
        id="elumi4vzut6uj"
        className="animable"
      />
      <rect
        x="330.82"
        y="228.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '332.485px 230.545px',
        }}
        id="el80oteilfdl"
        className="animable"
      />
      <rect
        x="330.82"
        y="234.61"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '332.485px 236.275px',
        }}
        id="el6ha1jvic1m5"
        className="animable"
      />
      <rect
        x="330.82"
        y="240.34"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '332.485px 242.005px',
        }}
        id="elfqfguzmsegg"
        className="animable"
      />
      <rect
        x="316.73"
        y="245.87"
        width="3.26"
        height="5.16"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '318.36px 248.45px',
        }}
        id="eln7vply3teq"
        className="animable"
      />
      <path
        d="M343.91,251c0,.14-10.34.26-23.09.26s-23.1-.12-23.1-.26,10.34-.26,23.1-.26S343.91,250.89,343.91,251Z"
        style={{fill: 'rgb(255, 255, 255)', transformOrigin: '320.815px 251px'}}
        id="elp7az4mgzf68"
        className="animable"
      />
      <path
        d="M446.42,352.56a9.25,9.25,0,0,0,1.21-.18,5,5,0,0,0,3.73-4.5c0-1,0-2.06,0-3.23,0-2.33,0-5,0-8,0-12.13,0-29.67-.08-51.34a6.84,6.84,0,0,0-.19-2,4.66,4.66,0,0,0-.91-1.75,4.83,4.83,0,0,0-3.51-1.77H419.53l-40.69,0-93.24,0a4.76,4.76,0,0,0-4.49,3.17,8.2,8.2,0,0,0-.28,2.95v15.24q0,12.07,0,23.79t0,22.94a4.79,4.79,0,0,0,3,4.06,5.11,5.11,0,0,0,1.28.32c.43,0,.9,0,1.36,0h13.64l76.15.06,51.33.08,14,.05,3.63,0,1.24,0-1.24,0-3.63,0-14,.05-51.33.08-76.15.06H286.47c-.46,0-.92,0-1.41,0a5.3,5.3,0,0,1-4.72-4.83q0-11.26,0-23v-39c0-.51,0-1,0-1.54a5.09,5.09,0,0,1,.3-1.59,5.3,5.3,0,0,1,5-3.51l93.24,0,40.69,0,18.44,0,8.7,0a5.22,5.22,0,0,1,3.79,1.91,5.31,5.31,0,0,1,1,1.89,7.05,7.05,0,0,1,.19,2.08c0,21.67-.06,39.21-.08,51.34,0,3,0,5.72,0,8,0,1.17,0,2.24,0,3.24a5.12,5.12,0,0,1-.89,2.52,5,5,0,0,1-3,2,4.49,4.49,0,0,1-.92.13Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '366.021px 315.905px',
        }}
        id="elwg3k8bubuif"
        className="animable"
      />
      <rect
        x="288.04"
        y="287.68"
        width="61.88"
        height="55.83"
        rx="2.55"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '318.98px 315.595px',
        }}
        id="elt417v0jnd5"
        className="animable"
      />
      <polygon
        points="412.22 293.96 412.67 294.88 413.69 295.03 412.95 295.75 413.12 296.76 412.22 296.28 411.31 296.76 411.48 295.75 410.75 295.03 411.76 294.88 412.22 293.96"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '412.22px 295.36px',
        }}
        id="el6f77r70qc8y"
        className="animable"
      />
      <polygon
        points="416.18 293.96 416.63 294.88 417.65 295.03 416.91 295.75 417.08 296.76 416.18 296.28 415.27 296.76 415.44 295.75 414.71 295.03 415.72 294.88 416.18 293.96"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '416.18px 295.36px',
        }}
        id="elp892a4jbgni"
        className="animable"
      />
      <polygon
        points="420.14 293.96 420.59 294.88 421.61 295.03 420.87 295.75 421.05 296.76 420.14 296.28 419.23 296.76 419.4 295.75 418.67 295.03 419.68 294.88 420.14 293.96"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '420.14px 295.36px',
        }}
        id="elwgxfclf1ner"
        className="animable"
      />
      <polygon
        points="424.1 293.96 424.55 294.88 425.57 295.03 424.83 295.75 425 296.76 424.1 296.28 423.19 296.76 423.36 295.75 422.63 295.03 423.64 294.88 424.1 293.96"
        style={{fill: 'rgb(51, 102, 255)', transformOrigin: '424.1px 295.36px'}}
        id="eletdli1422tq"
        className="animable"
      />
      <polygon
        points="428.06 293.96 428.51 294.88 429.53 295.03 428.79 295.75 428.96 296.76 428.06 296.28 427.15 296.76 427.32 295.75 426.59 295.03 427.6 294.88 428.06 293.96"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '428.06px 295.36px',
        }}
        id="elrsssjzqoji"
        className="animable"
      />
      <path
        d="M407,304c0,.15-9.59.26-21.42.26s-21.42-.11-21.42-.26,9.59-.26,21.42-.26S407,303.88,407,304Z"
        style={{fill: 'rgb(224, 224, 224)', transformOrigin: '385.58px 304px'}}
        id="elt9py5fuhd0q"
        className="animable"
      />
      <path
        d="M440.75,311.29c0,.14-17.35.26-38.73.26s-38.74-.12-38.74-.26S380.62,311,402,311,440.75,311.14,440.75,311.29Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '402.015px 311.275px',
        }}
        id="elrn6u9dzbf9"
        className="animable"
      />
      <path
        d="M402.08,318.73c0,.14-8.52.26-19,.26s-19-.12-19-.26,8.51-.26,19-.26S402.08,318.58,402.08,318.73Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '383.08px 318.73px'}}
        id="elv41pyo8zyjm"
        className="animable"
      />
      <path
        d="M326.92,333.57a5.4,5.4,0,0,1,0-.63c0-.43,0-1,0-1.76,0-1.57,0-3.79-.06-6.58,0-5.64-.07-13.57-.12-22.91l.24.24-21.49,0c-.06.05.49-.49.25-.26h0v8.79c0,2.86,0,5.65,0,8.33,0,5.37,0,10.34,0,14.74l-.21-.21,15.6.11,4.34,0,1.15,0a2,2,0,0,1,.41,0,2.37,2.37,0,0,1-.37,0l-1.11,0-4.29.06-15.73.11h-.2v-.21c0-4.4,0-9.37,0-14.74,0-2.68,0-5.47,0-8.33,0-1.43,0-2.88,0-4.35v-4.44h0l.27-.27,21.49,0h.24v.23c-.05,9.4-.09,17.39-.12,23.06,0,2.77-.05,5-.07,6.53,0,.72,0,1.29,0,1.72A3.92,3.92,0,0,1,326.92,333.57Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.33px 317.43px',
        }}
        id="elne5rk4xn1he"
        className="animable"
      />
      <path
        d="M322.7,297.46a28.57,28.57,0,0,1,.24,4.23v.24h-.24l-2.84,0c.05.05-.5-.5-.26-.27h0v-1.16c0-.37,0-.74,0-1.1,0-.69,0-1.34,0-2v-.21h.21a15.64,15.64,0,0,1,2.84.21,21.23,21.23,0,0,1-2.84.21l.21-.21,0,2c0,.36,0,.73,0,1.1,0,.2,0,.39,0,.58v.58h0l-.26-.26,2.84,0-.24.23A35.85,35.85,0,0,1,322.7,297.46Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '321.242px 299.56px',
        }}
        id="elzg1sqsjshy9"
        className="animable"
      />
      <path
        d="M335,333.74a4.66,4.66,0,0,1-.51,0h-1.56l-6,0h-.15v-.15c-.06-7.17-.1-18.79-.1-31.88v-.26h8.54v.25c0,9.15-.08,17.18-.11,23,0,2.81-.06,5.08-.08,6.7,0,.74,0,1.33,0,1.78a4.35,4.35,0,0,1,0,.6,6.13,6.13,0,0,1,0-.66c0-.47,0-1.08,0-1.84,0-1.63,0-3.92-.07-6.76,0-5.75-.07-13.71-.12-22.79l.26.26h-8l.26-.27c0,13.09,0,24.71-.11,31.88l-.15-.16,5.87.21,1.59.07A4.19,4.19,0,0,1,335,333.74Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '330.95px 317.615px',
        }}
        id="el4mg801w0yen"
        className="animable"
      />
      <rect
        x="308.85"
        y="305.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '310.515px 307.355px',
        }}
        id="elkh8fhvi1gh"
        className="animable"
      />
      <rect
        x="314.51"
        y="305.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.175px 307.355px',
        }}
        id="elsghpfasxgv"
        className="animable"
      />
      <rect
        x="320.16"
        y="305.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '321.825px 307.355px',
        }}
        id="el98qa6j9mxw"
        className="animable"
      />
      <rect
        x="308.85"
        y="311.42"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '310.515px 313.085px',
        }}
        id="elqoonp3cmyw"
        className="animable"
      />
      <rect
        x="314.51"
        y="311.42"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.175px 313.085px',
        }}
        id="el5wijcmh83z6"
        className="animable"
      />
      <rect
        x="320.16"
        y="311.42"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '321.825px 313.085px',
        }}
        id="elcpobyiymu05"
        className="animable"
      />
      <rect
        x="308.85"
        y="317.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '310.515px 318.815px',
        }}
        id="el1yq7vu2u5kz"
        className="animable"
      />
      <rect
        x="314.51"
        y="317.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.175px 318.815px',
        }}
        id="eleooon7p7hzb"
        className="animable"
      />
      <rect
        x="320.16"
        y="317.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '321.825px 318.815px',
        }}
        id="eltuine4nip1d"
        className="animable"
      />
      <rect
        x="308.85"
        y="322.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '310.515px 324.545px',
        }}
        id="elw1qaijqnqpd"
        className="animable"
      />
      <rect
        x="314.51"
        y="322.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.175px 324.545px',
        }}
        id="el8ks75ze8nr"
        className="animable"
      />
      <rect
        x="320.16"
        y="322.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '321.825px 324.545px',
        }}
        id="eljy6g1pekky"
        className="animable"
      />
      <rect
        x="328.99"
        y="305.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '330.655px 307.355px',
        }}
        id="eln44xkpbpo6m"
        className="animable"
      />
      <rect
        x="328.99"
        y="311.42"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '330.655px 313.085px',
        }}
        id="elzl9w8pkfoq"
        className="animable"
      />
      <rect
        x="328.99"
        y="317.15"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '330.655px 318.815px',
        }}
        id="el6fx8p78jlj9"
        className="animable"
      />
      <rect
        x="328.99"
        y="322.88"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '330.655px 324.545px',
        }}
        id="elpnucacjv47"
        className="animable"
      />
      <rect
        x="314.89"
        y="328.41"
        width="3.26"
        height="5.16"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.52px 330.99px',
        }}
        id="elvgrsnple4rb"
        className="animable"
      />
      <path
        d="M342.08,333.57c0,.14-10.34.26-23.1.26s-23.09-.12-23.09-.26,10.33-.26,23.09-.26S342.08,333.42,342.08,333.57Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '318.985px 333.57px',
        }}
        id="elgfsburnv83p"
        className="animable"
      />
      <rect
        x="288.81"
        y="369.68"
        width="61.88"
        height="55.83"
        rx="2.55"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '319.75px 397.595px',
        }}
        id="elp11uih7exyd"
        className="animable"
      />
      <polygon
        points="411.32 375.96 411.78 376.88 412.79 377.02 412.06 377.74 412.23 378.75 411.32 378.27 410.41 378.75 410.59 377.74 409.85 377.02 410.87 376.88 411.32 375.96"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '411.32px 377.355px',
        }}
        id="elrs9ipr3zhj"
        className="animable"
      />
      <polygon
        points="415.28 375.96 415.74 376.88 416.75 377.02 416.02 377.74 416.19 378.75 415.28 378.27 414.37 378.75 414.55 377.74 413.81 377.02 414.83 376.88 415.28 375.96"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '415.28px 377.355px',
        }}
        id="elyk75s5pgigq"
        className="animable"
      />
      <polygon
        points="419.24 375.96 419.7 376.88 420.71 377.02 419.98 377.74 420.15 378.75 419.24 378.27 418.33 378.75 418.51 377.74 417.77 377.02 418.79 376.88 419.24 375.96"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '419.24px 377.355px',
        }}
        id="elzqynju5w8ni"
        className="animable"
      />
      <polygon
        points="423.2 375.96 423.66 376.88 424.67 377.02 423.94 377.74 424.11 378.75 423.2 378.27 422.3 378.75 422.47 377.74 421.73 377.02 422.75 376.88 423.2 375.96"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '423.2px 377.355px',
        }}
        id="elngw4jdsm44"
        className="animable"
      />
      <polygon
        points="427.16 375.96 427.62 376.88 428.63 377.02 427.9 377.74 428.07 378.75 427.16 378.27 426.25 378.75 426.43 377.74 425.69 377.02 426.71 376.88 427.16 375.96"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '427.16px 377.355px',
        }}
        id="elf0xfxhoro4f"
        className="animable"
      />
      <path
        d="M407.77,386c0,.14-9.59.26-21.42.26s-21.42-.12-21.42-.26,9.59-.26,21.42-.26S407.77,385.87,407.77,386Z"
        style={{fill: 'rgb(224, 224, 224)', transformOrigin: '386.35px 386px'}}
        id="el69ax3vrh33j"
        className="animable"
      />
      <path
        d="M441.51,393.28c0,.15-17.34.26-38.73.26s-38.74-.11-38.74-.26,17.34-.26,38.74-.26S441.51,393.14,441.51,393.28Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '402.775px 393.28px'}}
        id="ellbjaw5qet4"
        className="animable"
      />
      <path
        d="M402.84,400.72c0,.14-8.52.26-19,.26s-19-.12-19-.26,8.52-.26,19-.26S402.84,400.58,402.84,400.72Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '383.84px 400.72px'}}
        id="ell02nerwtzba"
        className="animable"
      />
      <path
        d="M327.68,415.56a5.31,5.31,0,0,1,0-.62c0-.44,0-1,0-1.77,0-1.57,0-3.79-.06-6.58,0-5.64-.07-13.57-.12-22.9l.24.24-21.49,0,.26-.26h0v4.44c0,1.47,0,2.92,0,4.35q0,4.31,0,8.34c0,5.36,0,10.33,0,14.73l-.2-.21,15.59.11,4.34.06,1.15,0,.41,0a1.34,1.34,0,0,1-.36,0l-1.12,0-4.29.05-15.72.11H306v-.21c0-4.4,0-9.37,0-14.73,0-2.69,0-5.47,0-8.34V383.7h0l.26-.26,21.49,0h.24v.24c-.05,9.4-.09,17.38-.12,23.06,0,2.77-.05,5-.06,6.52,0,.73,0,1.3,0,1.72A3.75,3.75,0,0,1,327.68,415.56Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.995px 399.545px',
        }}
        id="elxrtakuo39on"
        className="animable"
      />
      <path
        d="M323.46,379.45a28.65,28.65,0,0,1,.24,4.24v.23h-.25l-2.84,0-.26-.26h0v-1.15c0-.38,0-.75,0-1.11l0-2v-.21h.2a15.49,15.49,0,0,1,2.84.21,21.23,21.23,0,0,1-2.84.21l.21-.21c0,.62,0,1.28,0,2,0,.36,0,.73,0,1.11v1.15h0l-.26-.26,2.84,0-.24.24A38.91,38.91,0,0,1,323.46,379.45Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '322.027px 381.554px',
        }}
        id="elf3jqbwo1hg6"
        className="animable"
      />
      <path
        d="M335.71,415.73a2.61,2.61,0,0,1-.51,0h-1.55l-6,0h-.15v-.16c-.06-7.17-.1-18.78-.1-31.87v-.26H336v.26c-.05,9.14-.09,17.17-.12,23,0,2.81-.06,5.07-.07,6.7,0,.73,0,1.33,0,1.78a4.08,4.08,0,0,1,0,.59,6.13,6.13,0,0,1,0-.66c0-.46,0-1.07,0-1.84,0-1.63,0-3.92-.07-6.76,0-5.75-.07-13.71-.11-22.78l.25.25h-8l.26-.26c0,13.09,0,24.7-.1,31.87l-.16-.15,5.88.21,1.58.07Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '331.7px 399.605px',
        }}
        id="elyi352w1w4xf"
        className="animable"
      />
      <rect
        x="309.61"
        y="387.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '311.275px 389.355px',
        }}
        id="eljiocql08dg"
        className="animable"
      />
      <rect
        x="315.27"
        y="387.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.935px 389.355px',
        }}
        id="elvy3o24ix0wl"
        className="animable"
      />
      <rect
        x="320.92"
        y="387.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '322.585px 389.355px',
        }}
        id="eliot3ujne7qk"
        className="animable"
      />
      <rect
        x="309.61"
        y="393.41"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '311.275px 395.075px',
        }}
        id="el3r98emjx0cz"
        className="animable"
      />
      <rect
        x="315.27"
        y="393.41"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.935px 395.075px',
        }}
        id="eliod5mwrj3f"
        className="animable"
      />
      <rect
        x="320.92"
        y="393.41"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '322.585px 395.075px',
        }}
        id="elwd9s7df89rp"
        className="animable"
      />
      <rect
        x="309.61"
        y="399.14"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '311.275px 400.805px',
        }}
        id="ely7l7yo9e8gp"
        className="animable"
      />
      <rect
        x="315.27"
        y="399.14"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.935px 400.805px',
        }}
        id="elfwnmcgov6bp"
        className="animable"
      />
      <rect
        x="320.92"
        y="399.14"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '322.585px 400.805px',
        }}
        id="elamj240vefl"
        className="animable"
      />
      <rect
        x="309.61"
        y="404.87"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '311.275px 406.535px',
        }}
        id="el4iel0gohvo"
        className="animable"
      />
      <rect
        x="315.27"
        y="404.87"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '316.935px 406.535px',
        }}
        id="elarwuuq43wkw"
        className="animable"
      />
      <rect
        x="320.92"
        y="404.87"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '322.585px 406.535px',
        }}
        id="el6as3ji1y75"
        className="animable"
      />
      <rect
        x="329.75"
        y="387.69"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '331.415px 389.355px',
        }}
        id="elnnoao9h5f2q"
        className="animable"
      />
      <rect
        x="329.75"
        y="393.41"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '331.415px 395.075px',
        }}
        id="el2ah3gzu95ex"
        className="animable"
      />
      <rect
        x="329.75"
        y="399.14"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '331.415px 400.805px',
        }}
        id="elk5jhl5ci1t"
        className="animable"
      />
      <rect
        x="329.75"
        y="404.87"
        width="3.33"
        height="3.33"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '331.415px 406.535px',
        }}
        id="el6e41p8ub2pw"
        className="animable"
      />
      <rect
        x="315.65"
        y="410.4"
        width="3.26"
        height="5.16"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '317.28px 412.98px',
        }}
        id="elng4r3fjsq0r"
        className="animable"
      />
      <path
        d="M342.84,415.56c0,.15-10.34.26-23.09.26s-23.1-.11-23.1-.26,10.34-.26,23.1-.26S342.84,415.42,342.84,415.56Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '319.745px 415.56px',
        }}
        id="els2rrj6dp2qn"
        className="animable"
      />
      <path
        d="M301.24,131.17H428.44a7.09,7.09,0,0,1,7.09,7.09v7.12a7.1,7.1,0,0,1-7.1,7.1H301.24a7.09,7.09,0,0,1-7.09-7.09v-7.12A7.1,7.1,0,0,1,301.24,131.17Z"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '364.84px 141.825px',
        }}
        id="elh7nwegnvbwb"
        className="animable"
      />
      <path
        d="M424.6,140.43s0-.26-.15-.7a3,3,0,0,0-1.08-1.55,2.84,2.84,0,0,0-2.67-.37,2.79,2.79,0,0,0,0,5.24,2.84,2.84,0,0,0,2.67-.37,3,3,0,0,0,1.08-1.55c.12-.44.12-.7.15-.7s0,.06,0,.19a2.71,2.71,0,0,1-.06.55,2.93,2.93,0,0,1-1.06,1.7,3.08,3.08,0,1,1,0-4.88,2.93,2.93,0,0,1,1.06,1.7,2.71,2.71,0,0,1,.06.55C424.62,140.37,424.61,140.43,424.6,140.43Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '421.567px 140.43px'}}
        id="elsygka4chd2"
        className="animable"
      />
      <path
        d="M426.23,145.51c-.07.07-.72-.52-1.45-1.31a5.67,5.67,0,0,1-1.19-1.54A5.7,5.7,0,0,1,425,144,6.12,6.12,0,0,1,426.23,145.51Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '424.91px 144.088px'}}
        id="el9hlrq37tym8"
        className="animable"
      />
      <path
        d="M307.66,140.75h-1.3v-.47h3.14v.47h-1.3v3.33h-.54Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '307.93px 142.18px'}}
        id="el4ar9ixbrmll"
        className="animable"
      />
      <path
        d="M309.46,142.64a1.5,1.5,0,1,1,1.5,1.48A1.43,1.43,0,0,1,309.46,142.64Zm2.46,0a.94.94,0,0,0-1-1,1,1,0,1,0,1,1Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '310.959px 142.621px',
        }}
        id="elze1p8o95q0n"
        className="animable"
      />
      <path
        d="M312.93,141.55a.37.37,0,1,1,.73,0,.37.37,0,1,1-.73,0Zm0,2.19a.37.37,0,1,1,.73,0,.37.37,0,1,1-.73,0Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '313.295px 142.645px',
        }}
        id="el43ie7qdv2ay"
        className="animable"
      />
      <path
        d="M396.81,142.76c0,.14-16.2.26-36.19.26s-36.2-.12-36.2-.26,16.2-.26,36.2-.26S396.81,142.61,396.81,142.76Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '360.615px 142.76px'}}
        id="elxxgw9wfncv"
        className="animable"
      />
      <rect
        x="294.15"
        y="159.81"
        width="141.38"
        height="21.31"
        rx="7.09"
        style={{
          fill: 'rgb(235, 235, 235)',
          transformOrigin: '364.84px 170.465px',
        }}
        id="el20w9qbrp2po"
        className="animable"
      />
      <path
        d="M424.6,170.07s0-.27-.15-.71a3,3,0,0,0-1.08-1.54,2.8,2.8,0,1,0,0,4.49,3,3,0,0,0,1.08-1.54c.12-.44.12-.71.15-.7s0,.06,0,.19a2.56,2.56,0,0,1-.06.54,2.93,2.93,0,0,1-1.06,1.7,3,3,0,0,1-2.91.48,3.09,3.09,0,0,1,0-5.83,3,3,0,0,1,2.91.48,2.93,2.93,0,0,1,1.06,1.7,2.58,2.58,0,0,1,.06.55A.52.52,0,0,1,424.6,170.07Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '421.559px 170.065px',
        }}
        id="elal3klrfsb"
        className="animable"
      />
      <path
        d="M426.23,175.15a5.86,5.86,0,0,1-1.45-1.32,5.67,5.67,0,0,1-1.19-1.54,11.71,11.71,0,0,1,2.64,2.86Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '424.91px 173.72px'}}
        id="el737dbzth456"
        className="animable"
      />
      <path
        d="M306.91,167.85h1.6a1.91,1.91,0,1,1,0,3.8h-1.6Zm1.57,3.33a1.43,1.43,0,1,0,0-2.86h-1v2.86Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '308.763px 169.75px'}}
        id="el21rgbbha5iri"
        className="animable"
      />
      <path
        d="M313.6,169.91v1.74h-.49v-.38a1.09,1.09,0,0,1-.95.41c-.65,0-1.06-.35-1.06-.85s.3-.84,1.15-.84h.83v-.1c0-.44-.26-.7-.77-.7a1.45,1.45,0,0,0-.91.31l-.22-.39a1.92,1.92,0,0,1,1.19-.37C313.16,168.74,313.6,169.12,313.6,169.91Zm-.52.86v-.4h-.8c-.52,0-.67.2-.67.44s.24.47.64.47A.84.84,0,0,0,313.08,170.77Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '312.35px 170.212px'}}
        id="el6hizyvnxgvy"
        className="animable"
      />
      <path
        d="M316.19,171.48a1,1,0,0,1-.63.2.83.83,0,0,1-.92-.9V169.2h-.48v-.43h.48v-.63h.53v.63H316v.43h-.82v1.56a.42.42,0,0,0,.45.48.66.66,0,0,0,.4-.13Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '315.175px 169.913px',
        }}
        id="eliffvp5gpj0n"
        className="animable"
      />
      <path
        d="M319.31,170.38H317a1,1,0,0,0,1,.85,1.08,1.08,0,0,0,.83-.35l.29.34a1.46,1.46,0,0,1-1.14.46,1.44,1.44,0,0,1-1.55-1.47,1.42,1.42,0,0,1,1.45-1.47,1.39,1.39,0,0,1,1.42,1.49A.76.76,0,0,1,319.31,170.38ZM317,170h1.84a.92.92,0,0,0-1.84,0Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '317.87px 170.212px'}}
        id="el5q0g8lezsvo"
        className="animable"
      />
      <path
        d="M319.8,169.11a.37.37,0,0,1,.37-.37.38.38,0,0,1,0,.75A.37.37,0,0,1,319.8,169.11Zm0,2.2a.36.36,0,0,1,.37-.37.35.35,0,0,1,.36.37.36.36,0,0,1-.36.37A.37.37,0,0,1,319.8,171.31Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '320.165px 170.21px'}}
        id="el1ngf17jlrmv"
        className="animable"
      />
      <path
        d="M338.32,170.39a44.07,44.07,0,0,1-9.56,0,44.07,44.07,0,0,1,9.56,0Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '333.54px 170.39px'}}
        id="el3ev91nqqmpt"
        className="animable"
      />
      <path
        d="M374.81,170.46c0,.15-6.88.26-15.35.26s-15.35-.11-15.35-.26,6.87-.26,15.35-.26S374.81,170.32,374.81,170.46Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '359.46px 170.46px'}}
        id="elj9kbiv0cmej"
        className="animable"
      />
    </g>
    <g
      id="freepik--character-2--inject-89"
      className="animable animator-active"
      style={{transformOrigin: '450.409px 307.387px'}}>
      <path
        d="M454.72,243.15l-39.66-3.94-6.49,7.24s39.71,13.63,41.84,13.53,8.33-9.24,8.33-9.24Z"
        style={{
          fill: 'rgb(255, 190, 157)',
          transformOrigin: '433.655px 249.595px',
        }}
        id="elothe97gbozi"
        className="animable"
      />
      <path
        d="M458.72,443.31l1.36,17.18s-16.94,6.78-17,10l33.33-1.06-1-26.86Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '459.745px 456.53px',
        }}
        id="elh0vwiugovdt"
        className="animable"
      />
      <path
        d="M470.12,458.67a1.38,1.38,0,0,1,1,1.53,1.31,1.31,0,0,1-1.5,1,1.44,1.44,0,0,1-1.07-1.62,1.36,1.36,0,0,1,1.68-.89"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '469.833px 459.927px',
        }}
        id="elg2vmpot7mc6"
        className="animable"
      />
      <path
        d="M476.41,469.41l-.08-2.14L444,469a2.53,2.53,0,0,0-1.08,1.71Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '459.665px 468.99px'}}
        id="elubnz86pcwjn"
        className="animable"
      />
      <path
        d="M459.78,460.61c0,.17.83.21,1.66.7s1.3,1.17,1.44,1.09-.13-1-1.15-1.59S459.73,460.46,459.78,460.61Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '461.346px 461.419px',
        }}
        id="elhzi5n93dj4m"
        className="animable"
      />
      <path
        d="M456.31,462.22c0,.16.69.41,1.28,1.08s.78,1.4.94,1.39.23-.95-.51-1.77S456.31,462.07,456.31,462.22Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '457.472px 463.42px'}}
        id="el60vq4g2vh1s"
        className="animable"
      />
      <path
        d="M454.49,466.53c.15,0,.34-.8-.12-1.68s-1.24-1.21-1.31-1.07.43.6.8,1.33S454.32,466.52,454.49,466.53Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '453.856px 465.139px',
        }}
        id="elnd96ocpoit"
        className="animable"
      />
      <path
        d="M459.9,456.63c.08.15.82-.11,1.75-.08s1.67.28,1.75.14-.64-.7-1.74-.72S459.82,456.51,459.9,456.63Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '461.65px 456.351px'}}
        id="el1hc79smigkk"
        className="animable"
      />
      <path
        d="M459.15,453a3.14,3.14,0,0,0,1.68-.08,7.59,7.59,0,0,0,1.74-.61,8.7,8.7,0,0,0,.95-.56,2,2,0,0,0,.49-.42.72.72,0,0,0,0-.87.92.92,0,0,0-.74-.35,2.22,2.22,0,0,0-.63.11,6.32,6.32,0,0,0-1,.41,5.77,5.77,0,0,0-1.51,1.09c-.75.75-1,1.38-.93,1.41s.43-.48,1.2-1.11a6.52,6.52,0,0,1,1.47-.92,6.23,6.23,0,0,1,.95-.33c.36-.11.66-.13.76,0s0,.08,0,.19a1.9,1.9,0,0,1-.36.3,8.76,8.76,0,0,1-2.48,1.24A11.08,11.08,0,0,0,459.15,453Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '461.653px 451.621px',
        }}
        id="elb5k7jv3nb1r"
        className="animable"
      />
      <path
        d="M500.81,443.31l1.35,17.18s-16.94,6.78-17,10l33.34-1.06-1-26.86Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '501.83px 456.53px',
        }}
        id="elam81bfu8d9d"
        className="animable"
      />
      <path
        d="M512.21,458.67a1.37,1.37,0,0,1,1,1.53,1.31,1.31,0,0,1-1.5,1,1.45,1.45,0,0,1-1.07-1.62,1.37,1.37,0,0,1,1.68-.89"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '511.925px 459.928px',
        }}
        id="elsglj1mzfz"
        className="animable"
      />
      <path
        d="M518.5,469.41l-.08-2.14L486.08,469a2.57,2.57,0,0,0-1.08,1.71Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '501.75px 468.99px'}}
        id="el4o0n4e8ifze"
        className="animable"
      />
      <path
        d="M501.86,460.61c0,.17.84.21,1.67.7s1.29,1.17,1.44,1.09-.14-1-1.16-1.59S501.82,460.46,501.86,460.61Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '503.433px 461.419px',
        }}
        id="el2bh5ez7tcll"
        className="animable"
      />
      <path
        d="M498.39,462.22c0,.16.69.41,1.28,1.08s.78,1.4.95,1.39.22-.95-.52-1.77S498.39,462.07,498.39,462.22Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '499.558px 463.42px'}}
        id="elain6kk6nwj7"
        className="animable"
      />
      <path
        d="M496.57,466.53c.15,0,.34-.8-.12-1.68s-1.24-1.21-1.31-1.07.44.6.8,1.33S496.4,466.52,496.57,466.53Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '495.937px 465.139px',
        }}
        id="elzdtyx89myg8"
        className="animable"
      />
      <path
        d="M502,456.63c.07.15.81-.11,1.75-.08s1.66.28,1.74.14-.64-.7-1.74-.72S501.9,456.51,502,456.63Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '503.744px 456.351px',
        }}
        id="elfsup9bu8te8"
        className="animable"
      />
      <path
        d="M501.23,453a3.14,3.14,0,0,0,1.68-.08,7.28,7.28,0,0,0,1.74-.61,7.85,7.85,0,0,0,1-.56,2,2,0,0,0,.49-.42.7.7,0,0,0,0-.87.89.89,0,0,0-.74-.35,2.29,2.29,0,0,0-.63.11,6.32,6.32,0,0,0-1,.41,5.94,5.94,0,0,0-1.51,1.09c-.75.75-1,1.38-.93,1.41s.43-.48,1.2-1.11a6.75,6.75,0,0,1,1.47-.92,7.09,7.09,0,0,1,1-.33c.36-.11.66-.13.76,0s0,.08,0,.19a1.43,1.43,0,0,1-.36.3,8.36,8.36,0,0,1-.87.55,9.76,9.76,0,0,1-1.6.69A11,11,0,0,0,501.23,453Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '503.761px 451.62px'}}
        id="elhkdqyoy8srw"
        className="animable"
      />
      <path
        d="M476.11,294.36c-1.57,2-33.32,76-33.32,83.49s11.87,76.91,11.87,76.91l21.8-.75s1.61-37.36-.35-48.33S472.72,380,472.72,380l31.22-55.07s3.52-21.17,0-27.44S476.11,294.36,476.11,294.36Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '474.147px 374.167px',
        }}
        id="elnub3xyba15l"
        className="animable"
      />
      <path
        d="M474.15,351.59c0,.78,11.34,32.49,13.19,42.29s10.18,61.7,10.18,61.7l21.7-1.57s-2-55-5.48-69.89-6.28-27.44-6.28-36.06,2.68-8.64,1.54-21-14.08-16.25-14.08-16.25Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '496.685px 383.195px',
        }}
        id="el13iz54ol71p"
        className="animable"
      />
      <path
        d="M489.67,347.12a6.38,6.38,0,0,1-.4,1.4c-.28.9-.74,2.18-1.35,3.74a114.06,114.06,0,0,1-12.27,23.13c-1,1.38-1.76,2.48-2.34,3.22a6.35,6.35,0,0,1-.94,1.11,7.56,7.56,0,0,1,.76-1.24l2.18-3.31c1.83-2.81,4.24-6.75,6.64-11.26s4.3-8.72,5.6-11.8c.6-1.47,1.11-2.69,1.52-3.66A7.8,7.8,0,0,1,489.67,347.12Z"
        style={{fill: 'rgb(69, 90, 100)', transformOrigin: '481.02px 363.42px'}}
        id="elft7jsxg9qqt"
        className="animable"
      />
      <path
        d="M474.59,175.42a7.73,7.73,0,0,1-2.13-8,1,1,0,0,0-.48-1.53,5.76,5.76,0,0,1-2.46-3.77,4.46,4.46,0,0,1,1.59-4.13c-2.15-1-2.78-4.14-1.5-6.16a6,6,0,0,1,6.28-2.33,3.4,3.4,0,0,1,.93-3.94,6.7,6.7,0,0,1,4-1.46c1.94-.15,4.21.31,5.13,2a3,3,0,0,1,2.69-2,6.53,6.53,0,0,1,7.06,5.12,5.93,5.93,0,0,1,3.48-1,2.8,2.8,0,0,1,2.58,2.23,3.56,3.56,0,0,1,3.2-1.34,4.32,4.32,0,0,1,2.49.67,2.15,2.15,0,0,1,.9,2.29,3.42,3.42,0,0,1,2.29,6.41,4.37,4.37,0,0,1-.47,7.41,1.2,1.2,0,0,1,.59,1.78,2.34,2.34,0,0,1-1.92.9c0,2.55.05,5.09.08,7.63a15.35,15.35,0,0,1-.47,4.88,5.22,5.22,0,0,1-3.14,3.54"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '490.775px 164.342px',
        }}
        id="el0txm8srfwma"
        className="animable"
      />
      <path
        d="M474.57,168.07c.26-6.15,6.73-12.43,12.85-11.92l19.86,3.37v3.31l.25,42.71-23.08,10.2.32-16s-7.85-1.14-9.67-11.35C474.19,183.28,474.27,174.91,474.57,168.07Z"
        style={{
          fill: 'rgb(255, 190, 157)',
          transformOrigin: '490.947px 185.93px',
        }}
        id="el9dhmrewsaeh"
        className="animable"
      />
      <path
        d="M476.93,175.08a1.31,1.31,0,0,0,1.29,1.3,1.25,1.25,0,0,0,1.32-1.21,1.3,1.3,0,0,0-1.28-1.3A1.25,1.25,0,0,0,476.93,175.08Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '478.235px 175.125px',
        }}
        id="elnv12nktc4gg"
        className="animable"
      />
      <path
        d="M476.46,172.38c.16.17,1.14-.59,2.55-.61s2.45.66,2.6.48-.09-.38-.55-.7A3.58,3.58,0,0,0,479,171a3.44,3.44,0,0,0-2,.7C476.52,172,476.38,172.31,476.46,172.38Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '479.047px 171.701px',
        }}
        id="eldd112nnc38e"
        className="animable"
      />
      <path
        d="M489.62,175.55a1.31,1.31,0,0,0,1.29,1.3,1.26,1.26,0,0,0,1.33-1.21,1.31,1.31,0,0,0-1.29-1.3A1.26,1.26,0,0,0,489.62,175.55Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '490.93px 175.595px'}}
        id="eljbocsfs41"
        className="animable"
      />
      <path
        d="M490.28,172.66c.16.17,1.14-.59,2.55-.62s2.45.66,2.6.49-.09-.39-.55-.71a3.58,3.58,0,0,0-2.09-.6,3.51,3.51,0,0,0-2,.71C490.34,172.27,490.2,172.58,490.28,172.66Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '492.867px 171.952px',
        }}
        id="elmeyn7t1dhp"
        className="animable"
      />
      <path
        d="M485.41,183a9.56,9.56,0,0,0-2.3-.36c-.36,0-.7-.1-.77-.34a1.92,1.92,0,0,1,.22-1.08c.32-.88.66-1.8,1-2.77,1.4-4,2.4-7.19,2.24-7.25a48.49,48.49,0,0,0-2.81,7L482,181a2.1,2.1,0,0,0-.16,1.42.92.92,0,0,0,.61.52,2.85,2.85,0,0,0,.61.07A8.88,8.88,0,0,0,485.41,183Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '483.8px 177.142px'}}
        id="elydv4lk6dhbl"
        className="animable"
      />
      <path
        d="M484.77,199.71a25.88,25.88,0,0,0,13.59-4s-3.41,7.29-13.64,6.55Z"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '491.54px 199.011px',
        }}
        id="elgepfodd0vp"
        className="animable"
      />
      <path
        d="M486.07,186.35a2.56,2.56,0,0,1,2.26-1,2.33,2.33,0,0,1,1.61.83,1.47,1.47,0,0,1,.15,1.69,1.7,1.7,0,0,1-1.84.5,5.28,5.28,0,0,1-1.82-1,1.6,1.6,0,0,1-.41-.41.47.47,0,0,1,0-.52"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '488.115px 186.901px',
        }}
        id="elpahz55qjk6"
        className="animable"
      />
      <path
        d="M489.57,183.84c-.23,0-.2,1.53-1.49,2.65s-2.91,1-2.92,1.2.37.29,1.06.29a3.82,3.82,0,0,0,2.44-.91,3.39,3.39,0,0,0,1.15-2.22C489.85,184.21,489.68,183.83,489.57,183.84Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '487.488px 185.91px'}}
        id="elwb6takvk9q9"
        className="animable"
      />
      <path
        d="M489.75,167.61c.15.39,1.55.17,3.21.34s3,.59,3.21.24c.09-.17-.14-.53-.69-.89a5.34,5.34,0,0,0-2.4-.78,5.26,5.26,0,0,0-2.49.35C490,167.12,489.69,167.43,489.75,167.61Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '492.966px 167.409px',
        }}
        id="elx6pjaeex0n"
        className="animable"
      />
      <path
        d="M476.89,168.28c.26.31,1.22,0,2.39-.08s2.16.17,2.38-.17c.09-.17-.07-.48-.51-.78a3.41,3.41,0,0,0-3.83.2C476.91,167.79,476.78,168.12,476.89,168.28Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '479.268px 167.585px',
        }}
        id="elyathro7u0s9"
        className="animable"
      />
      <path
        d="M478.54,156.17a5,5,0,0,0,7,5.94,1.94,1.94,0,0,0,.11,2.56,3.63,3.63,0,0,0,2.55,1,6.86,6.86,0,0,0,5.29-2.22,5,5,0,0,0,7.2,3.77,4.78,4.78,0,0,0-.91,5.29,4.7,4.7,0,0,0,4.68,2.58,4.75,4.75,0,0,0,4-3.6,5.18,5.18,0,0,0,1.86-8,3.1,3.1,0,0,0,1.92-2.42,6.21,6.21,0,0,0-.39-3.18,9.86,9.86,0,0,0-5-5.86,6.61,6.61,0,0,0-7.33,1.19,1.41,1.41,0,0,1-.71.52,1.28,1.28,0,0,1-1-.53c-1.27-1.29-2.59-2.68-4.34-3.12A4.84,4.84,0,0,0,488,152.7a5.65,5.65,0,0,0-6.2-2.64c-2.32.72-3.79,3.66-2.66,5.8"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '495.311px 162.508px',
        }}
        id="el33boc4ibtt"
        className="animable"
      />
      <path
        d="M503.45,173.58a22.25,22.25,0,0,0,1.31,6.08c.31.83.79,1.75,1.65,1.92a1.88,1.88,0,0,0,1.93-1.13,5,5,0,0,0,.33-2.37,65.93,65.93,0,0,0-1.05-8.51"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '506.073px 175.58px'}}
        id="elwbdrr2yi4m"
        className="animable"
      />
      <path
        d="M505.71,175.15c.13-.06,5.12-1.91,5.31,3.32s-5.08,4.34-5.09,4.19S505.71,175.15,505.71,175.15Z"
        style={{
          fill: 'rgb(255, 190, 157)',
          transformOrigin: '508.367px 178.797px',
        }}
        id="ele178dr8genn"
        className="animable"
      />
      <path
        d="M507.44,180.62s.1.06.25.13a.93.93,0,0,0,.68,0,2.28,2.28,0,0,0,1-2.06,3.15,3.15,0,0,0-.3-1.3,1.07,1.07,0,0,0-.71-.67.46.46,0,0,0-.53.27c-.06.15,0,.25-.05.26s-.12-.08-.08-.3a.54.54,0,0,1,.19-.34.73.73,0,0,1,.5-.15,1.26,1.26,0,0,1,1,.78,3,3,0,0,1,.37,1.44,2.37,2.37,0,0,1-1.24,2.31,1,1,0,0,1-.84-.11C507.46,180.75,507.43,180.63,507.44,180.62Z"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '508.604px 178.747px',
        }}
        id="el6sh7pb7xwvw"
        className="animable"
      />
      <path
        d="M493.77,162.41l-.16.05-.48.08a7.1,7.1,0,0,1-1.84,0,4.73,4.73,0,0,1-1.29-.31,3.89,3.89,0,0,1-1.33-.85,3.75,3.75,0,0,1-.93-1.53,2.81,2.81,0,0,1,.12-2l.17.14a6.85,6.85,0,0,1-4.13,1.35,6.63,6.63,0,0,1-2.38-.44,4.32,4.32,0,0,1-1.11-.61,2.41,2.41,0,0,1-.77-1.06,3.4,3.4,0,0,1-.16-1.51,9.41,9.41,0,0,1,.27-1.44,4.53,4.53,0,0,1,.51-1.34,1.65,1.65,0,0,1,1.13-.84l.06.24a4.09,4.09,0,0,1-2.68,0,4.39,4.39,0,0,1-2-1.42,3.67,3.67,0,0,1-.81-2,4.37,4.37,0,0,1,.27-1.85,4.25,4.25,0,0,1,1.61-2.07,2.61,2.61,0,0,1,.85-.4,7,7,0,0,0-.8.47,4.27,4.27,0,0,0-1.74,3.84,3.57,3.57,0,0,0,.78,1.91,4.24,4.24,0,0,0,1.92,1.33,3.88,3.88,0,0,0,2.52,0l.06.25a1.4,1.4,0,0,0-.95.72,4.51,4.51,0,0,0-.48,1.27,5,5,0,0,0-.11,2.8,2.71,2.71,0,0,0,1.73,1.52,6.47,6.47,0,0,0,2.28.42,6.56,6.56,0,0,0,4-1.28l.38-.27-.21.42a2.64,2.64,0,0,0-.12,1.83,3.7,3.7,0,0,0,.87,1.46,3.55,3.55,0,0,0,1.25.83,4.88,4.88,0,0,0,1.24.33,8.17,8.17,0,0,0,1.83,0Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '484.86px 153.6px',
        }}
        id="elnujuyqauf9s"
        className="animable"
      />
      <path
        d="M477.64,160.46a1,1,0,0,1-.35.17,2.88,2.88,0,0,1-1.05.14,2.7,2.7,0,0,1-1.48-.54,1.32,1.32,0,0,1-.5-.86,1,1,0,0,1,.45-1l.11.24-.09,0a4.1,4.1,0,0,1-3.44-.5,3.55,3.55,0,0,1-.81-.72,1.21,1.21,0,0,1-.21-.33,8.43,8.43,0,0,0,1.12.89,4.09,4.09,0,0,0,3.26.41l.08,0L476,158l-1.13.61a.73.73,0,0,0-.32.72,1.06,1.06,0,0,0,.39.69,2.57,2.57,0,0,0,1.35.54A4.62,4.62,0,0,0,477.64,160.46Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '473.955px 158.917px',
        }}
        id="elv62vmo08nle"
        className="animable"
      />
      <path
        d="M482.2,172.06s-.31-.23-.85-.52a5,5,0,0,0-2.25-.64,5.09,5.09,0,0,0-2.29.48c-.55.26-.85.5-.88.46a2.21,2.21,0,0,1,.8-.63,4.58,4.58,0,0,1,4.72.17A2.18,2.18,0,0,1,482.2,172.06Z"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '479.065px 171.348px',
        }}
        id="elg3x1acg22em"
        className="animable"
      />
      <path
        d="M496,171.74a6.17,6.17,0,0,1-.69-.41,4.19,4.19,0,0,0-1.82-.5,4,4,0,0,0-1.84.37c-.45.2-.7.39-.73.35s.19-.26.64-.52a3.69,3.69,0,0,1,3.84.14C495.84,171.46,496,171.72,496,171.74Z"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '493.459px 171.149px',
        }}
        id="elspq8pi1ok5m"
        className="animable"
      />
      <path
        d="M490.83,184.35s-.1-.09-.23-.21a1.51,1.51,0,0,0-.58-.35c-.53-.14-1-.14-1-.23a1.5,1.5,0,0,1,1.1,0,1.25,1.25,0,0,1,.65.48C490.86,184.2,490.86,184.34,490.83,184.35Z"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '489.934px 183.903px',
        }}
        id="elxgntcpjom68"
        className="animable"
      />
      <path
        d="M491.83,185.09c-.07,0-.19-.38-.4-.82s-.43-.79-.38-.84.39.24.62.73S491.9,185.08,491.83,185.09Z"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '491.457px 184.257px',
        }}
        id="eldyix7hi078u"
        className="animable"
      />
      <path
        d="M387.65,238.08c-.18,0-.74-7-.74-7s2.55.57,3,2.39.8,3.37.8,3.37l6.38,1.88,6.75-2.06L401,241.06s-3.65.5-3.93.49S387.65,238.08,387.65,238.08Z"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '395.375px 236.315px',
        }}
        id="el1t2o0t7nqh9"
        className="animable"
      />
      <path
        d="M409.32,246.67l-14.83-1.57s-11.15-6.92-12.41-7.78a1.1,1.1,0,0,1-.5-.78,1.4,1.4,0,0,1,1.9-1.44l13.11,4.75a2.88,2.88,0,0,0,2.38-.24l5.57-3.27s-2.25-2.18-3.67-3.86a2.65,2.65,0,0,1-.36-3.2c1.78.26,10.76,7,10.76,7l3.75,2.94Z"
        style={{
          fill: 'rgb(255, 190, 157)',
          transformOrigin: '398.297px 237.975px',
        }}
        id="el8drhk8bxry"
        className="animable"
      />
      <path
        d="M390.64,237l2.05-5.79a2,2,0,0,1,1.56,2.45c-.21,2.22-.18,4.1-.18,4.1l3,1.24-6.44-1.85"
        style={{
          fill: 'rgb(235, 153, 110)',
          transformOrigin: '393.85px 235.105px',
        }}
        id="elwtf6w3i739"
        className="animable"
      />
      <path
        d="M510.81,182.06a2.28,2.28,0,0,1,.86.59,5.4,5.4,0,0,1,1.51,2.39,4.83,4.83,0,0,1-.65,4.13,4.69,4.69,0,0,1-4.68,1.92,4.29,4.29,0,0,1-2.4-1.32,5.63,5.63,0,0,1-1.26-2.2,4.88,4.88,0,0,1,.53-4.15,4.35,4.35,0,0,1,2.27-1.69,2,2,0,0,1,1-.12s-.36.07-1,.31a4.3,4.3,0,0,0-2,1.7,4.58,4.58,0,0,0-.38,3.81,4.43,4.43,0,0,0,3.29,3.15,4.24,4.24,0,0,0,4.2-1.68,4.52,4.52,0,0,0,.69-3.76,5.72,5.72,0,0,0-1.31-2.35C511.09,182.31,510.79,182.09,510.81,182.06Z"
        style={{
          fill: 'rgb(69, 90, 100)',
          transformOrigin: '508.666px 186.379px',
        }}
        id="elottrepmozaj"
        className="animable"
      />
      <path
        d="M507.44,202.31c5.09,5.7,9,18.43,10,26,1.07,8.5.71,10.7,1.36,17.67.67,7.24.93,56.47-1.81,60.28s-4.91,4.36-4.91,4.36-.36,3.82-.73,11.63S498.8,350.4,498.8,350.4s-2.36,3.45-7.26-2.18c-3.59-4.11-9.5-18-12.42-25.22a36.75,36.75,0,0,0-4.72-8.32h0a2.53,2.53,0,0,0-4,0L462.63,325s-4.14-2.56-4.5-5.29,2.18-10.17,4.54-18.52,6.1-37,6.1-37-.11-28.61,0-29c1-3.71,6.69-11,10.5-17.38a52.16,52.16,0,0,0,5.37-12.57l22.8-2.86Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '488.67px 276.878px',
        }}
        id="eljqqqa25z5fa"
        className="animable"
      />
      <g id="elslxovoejmx9">
        <g
          style={{opacity: '0.3', transformOrigin: '485.747px 249.398px'}}
          className="animable">
          <path
            d="M468.47,261.7c8.22.39,23.75-6.94,25.37-8.1,4.31-3.11,9.59-10.06,9.16-16.52a36.82,36.82,0,0,1-16.14,16.08,41.92,41.92,0,0,1-6.63,3.24"
            id="el9a7yqt2ouv6"
            className="animable"
            style={{transformOrigin: '485.747px 249.398px'}}
          />
        </g>
      </g>
      <path
        d="M467,236.72A93.74,93.74,0,0,0,482.4,219c3.4-5.24,10.05-3.65,18.76,1.25,3.27,1.84,3.83,5.77,3.26,10A27,27,0,0,1,491,249.71c-10.48,6-27.07,14.39-29.9,15.64-2.3,1-7.4,1.13-11.74-1.33l1.45-26.14s8.76-2.57,12.24-.8l1.4.89,2.62-1.25"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '476.988px 240.886px',
        }}
        id="elqqn1k7t87j"
        className="animable"
      />
      <path
        d="M503,215.44s-.44-.51-1.39-1.22a10.3,10.3,0,0,0-4.59-1.8,11.83,11.83,0,0,0-7.14,1.21,21.76,21.76,0,0,0-6.82,5.88c-1,1.26-1.89,2.58-2.78,3.84s-1.82,2.44-2.74,3.52a64.56,64.56,0,0,1-5.23,5.42c-1.57,1.46-2.9,2.57-3.83,3.32-.46.38-.83.66-1.08.85s-.39.28-.41.26a14.76,14.76,0,0,1,1.35-1.28c.88-.8,2.17-2,3.7-3.44s3.29-3.31,5.1-5.47c.9-1.08,1.81-2.24,2.68-3.5s1.77-2.59,2.79-3.88a24.92,24.92,0,0,1,3.32-3.47,17.07,17.07,0,0,1,3.72-2.52,12.08,12.08,0,0,1,7.43-1.14,10,10,0,0,1,4.67,2,6.81,6.81,0,0,1,1,1A1.79,1.79,0,0,1,503,215.44Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '484.995px 224.29px'}}
        id="elzj2m99iw4lf"
        className="animable"
      />
      <path
        d="M476.64,257.88a13.85,13.85,0,0,1,1.78-.86c1.15-.52,2.82-1.27,4.85-2.27s4.42-2.25,7-3.79a27.32,27.32,0,0,0,7.29-6.26,43.66,43.66,0,0,0,3-4,34.79,34.79,0,0,0,2.4-4,28.84,28.84,0,0,0,2.54-7.45,19.24,19.24,0,0,0,.32-5.3c-.12-1.25-.33-1.92-.27-1.94a1.5,1.5,0,0,1,.17.48,10.54,10.54,0,0,1,.32,1.44,17.9,17.9,0,0,1-.14,5.39,28.09,28.09,0,0,1-2.47,7.62A35.27,35.27,0,0,1,501,241a46.19,46.19,0,0,1-3,4.08,27.34,27.34,0,0,1-7.46,6.35c-2.59,1.51-5,2.74-7.07,3.7s-3.77,1.65-4.95,2.11c-.59.23-1.05.4-1.37.51A2.37,2.37,0,0,1,476.64,257.88Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '491.41px 239.945px'}}
        id="elxjecto5r8lc"
        className="animable"
      />
      <path
        d="M486.21,339.13a5.74,5.74,0,0,1,.17-.92c.12-.6.37-1.47.57-2.62a64.06,64.06,0,0,0,1.08-9.77c.18-4.15-.06-9.1-.29-14.61a99,99,0,0,1,.55-17.93,170.88,170.88,0,0,1,3.78-17.53,110.62,110.62,0,0,0,2.82-14.32,49.07,49.07,0,0,0,.2-9.81c-.06-1.16-.25-2.05-.3-2.66a5.4,5.4,0,0,1-.09-.93,5.09,5.09,0,0,1,.2.91c.09.61.32,1.49.41,2.66a45.85,45.85,0,0,1,0,9.87,104,104,0,0,1-2.71,14.4c-1.28,5.36-2.86,11.21-3.73,17.49a101.84,101.84,0,0,0-.59,17.84c.21,5.49.41,10.47.17,14.64a58.29,58.29,0,0,1-1.26,9.8c-.24,1.14-.52,2-.67,2.6A5.11,5.11,0,0,1,486.21,339.13Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '490.893px 293.58px'}}
        id="elzoc5c827h2g"
        className="animable"
      />
      <path
        d="M464.47,254.93a12,12,0,0,1,0-2.49c0-1.53.1-3.65.11-6s0-4.45-.05-6a13.85,13.85,0,0,1,0-2.49,10.73,10.73,0,0,1,.33,2.47c.13,1.54.22,3.67.21,6s-.13,4.48-.27,6A10.47,10.47,0,0,1,464.47,254.93Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '464.738px 246.44px'}}
        id="eldf0ri7ep7u6"
        className="animable"
      />
      <path
        d="M476.25,252.24a20.76,20.76,0,0,1-3.33-3.21,20.11,20.11,0,0,1-2.95-3.56,21.18,21.18,0,0,1,3.33,3.21A20.25,20.25,0,0,1,476.25,252.24Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '473.11px 248.855px'}}
        id="elw9ekiihqohg"
        className="animable"
      />
      <path
        d="M477.7,242a10.54,10.54,0,0,1,0-3.28,10.69,10.69,0,0,1,.51-3.24,10.18,10.18,0,0,1,0,3.28A10.69,10.69,0,0,1,477.7,242Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '477.957px 238.74px'}}
        id="elqpurdjkqso"
        className="animable"
      />
      <path
        d="M486.67,243.77a12,12,0,0,1-1-3.46,12.47,12.47,0,0,1-.5-3.56,12.65,12.65,0,0,1,1,3.45A13,13,0,0,1,486.67,243.77Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '485.92px 240.26px'}}
        id="el231i5owxnov"
        className="animable"
      />
      <path
        d="M490.75,223.48a9.52,9.52,0,0,1-3.13.39,9.31,9.31,0,0,1-3.14-.14,19.4,19.4,0,0,1,6.27-.25Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '487.615px 223.639px',
        }}
        id="el25bu6ij48nt"
        className="animable"
      />
      <path
        d="M495.27,237a45.86,45.86,0,0,1,2-9.54,22.65,22.65,0,0,1-.75,4.82A23.12,23.12,0,0,1,495.27,237Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '496.27px 232.23px'}}
        id="elinf9jkjx7k"
        className="animable"
      />
      <path
        d="M501.53,222.43a9.26,9.26,0,0,1-2.87-1.14,9.53,9.53,0,0,1-2.65-1.62,9.66,9.66,0,0,1,2.88,1.15A9.23,9.23,0,0,1,501.53,222.43Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '498.77px 221.05px'}}
        id="elhiv5jp66j7i"
        className="animable"
      />
      <path
        d="M453.77,245.88a15,15,0,0,1,3-2.54,15.31,15.31,0,0,1,3.33-2.13,15.21,15.21,0,0,1-3,2.55A15.48,15.48,0,0,1,453.77,245.88Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '456.935px 243.545px',
        }}
        id="elli9xuup7ly"
        className="animable"
      />
      <path
        d="M460.15,252a9.81,9.81,0,0,1-3-1,9.61,9.61,0,0,1-2.78-1.5,9.92,9.92,0,0,1,3,1A9.74,9.74,0,0,1,460.15,252Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '457.26px 250.75px'}}
        id="elxmje35lpwem"
        className="animable"
      />
      <path
        d="M456.88,260.56c.11.08-.33.87-1.21,1.52s-1.75.87-1.8.74.68-.54,1.49-1.15S456.76,260.47,456.88,260.56Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '455.382px 261.703px',
        }}
        id="elgsvh5ukbr1a"
        className="animable"
      />
      <path
        d="M510.35,214.87a12.15,12.15,0,0,1-2.58-2.45,12.46,12.46,0,0,1-2.2-2.81,24.2,24.2,0,0,1,4.78,5.26Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '507.96px 212.24px'}}
        id="el6k55iptcr47"
        className="animable"
      />
      <path
        d="M512.55,227.94a7.11,7.11,0,0,1-1.56,2.17c-1,1.11-1.85,1.93-2,1.83a7.49,7.49,0,0,1,1.57-2.17C511.57,228.66,512.44,227.84,512.55,227.94Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '510.77px 229.94px'}}
        id="eljemgczjcagj"
        className="animable"
      />
      <path
        d="M506.05,251a21.66,21.66,0,0,1-1.44-2.43,21,21,0,0,1-1.57-2.34,5,5,0,0,1,2,2.07A4.93,4.93,0,0,1,506.05,251Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '504.545px 248.615px',
        }}
        id="el3siialzp997"
        className="animable"
      />
      <path
        d="M513.82,242.75a18.52,18.52,0,0,1-1.75,6,9.46,9.46,0,0,1,.63-3.08A10,10,0,0,1,513.82,242.75Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '512.945px 245.75px'}}
        id="eljrsq7rvio"
        className="animable"
      />
      <path
        d="M505.55,267.84a10.32,10.32,0,0,1-1.69-2.73,10.07,10.07,0,0,1-1.22-3,19.32,19.32,0,0,1,2.91,5.69Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '504.095px 264.975px',
        }}
        id="el6x0sh9gkqu6"
        className="animable"
      />
      <path
        d="M515.08,263.34a9.16,9.16,0,0,1-3.05-.12,9,9,0,0,1-3-.64,9.09,9.09,0,0,1,3,.12A8.94,8.94,0,0,1,515.08,263.34Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '512.055px 262.962px',
        }}
        id="elsci8le9anlg"
        className="animable"
      />
      <path
        d="M498.91,283.07a66.13,66.13,0,0,1,2.93-5.93,8.19,8.19,0,0,1-1.07,3.16A8,8,0,0,1,498.91,283.07Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '500.375px 280.105px',
        }}
        id="elkvu49k06oeb"
        className="animable"
      />
      <path
        d="M511.74,285.19a16.4,16.4,0,0,1-2.34-3.38,16.12,16.12,0,0,1-1.89-3.66,16.66,16.66,0,0,1,2.34,3.39A17,17,0,0,1,511.74,285.19Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '509.625px 281.67px'}}
        id="elvkrt7897sj"
        className="animable"
      />
      <path
        d="M502.35,302a23.55,23.55,0,0,1,.11-5,24.06,24.06,0,0,1,.64-5,24.85,24.85,0,0,1-.12,5A25.35,25.35,0,0,1,502.35,302Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '502.72px 297px'}}
        id="elp3syve7ouym"
        className="animable"
      />
      <path
        d="M494.57,309a18.54,18.54,0,0,1-1.83-6,9.56,9.56,0,0,1,1.16,2.93A9.8,9.8,0,0,1,494.57,309Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '493.655px 306px'}}
        id="elpm38tneibw"
        className="animable"
      />
      <path
        d="M500,323.28a12,12,0,0,1-2.62,2.31,11.53,11.53,0,0,1-2.94,1.9,12,12,0,0,1,2.62-2.31A12.24,12.24,0,0,1,500,323.28Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '497.22px 325.385px'}}
        id="elna4l1gfsl4"
        className="animable"
      />
      <path
        d="M506.3,318.26a16.89,16.89,0,0,1-.39-4.13,16.19,16.19,0,0,1,.14-4.15,17.2,17.2,0,0,1,.38,4.13A17,17,0,0,1,506.3,318.26Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '506.169px 314.12px'}}
        id="elmnjn8uqb62k"
        className="animable"
      />
      <path
        d="M502.62,334.17c.09.11-.52.75-1.36,1.43s-1.61,1.13-1.7,1,.53-.75,1.37-1.43S502.53,334.06,502.62,334.17Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '501.09px 335.388px'}}
        id="elwo6iubsq6xe"
        className="animable"
      />
      <path
        d="M513.17,301.47a13.42,13.42,0,0,1,.34-3.69,13.56,13.56,0,0,1,.85-3.6,13.4,13.4,0,0,1-.34,3.69A13.56,13.56,0,0,1,513.17,301.47Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '513.765px 297.825px',
        }}
        id="elnwds7zam7f8"
        className="animable"
      />
      <path
        d="M484.19,273.13a11,11,0,0,1-1.95-2.64,10.49,10.49,0,0,1-1.51-2.91,10.26,10.26,0,0,1,1.95,2.63A10.47,10.47,0,0,1,484.19,273.13Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '482.46px 270.355px'}}
        id="el6gk5to92bk"
        className="animable"
      />
      <path
        d="M491,262.32c.08.12-.64.77-1.61,1.47s-1.82,1.15-1.91,1,.64-.78,1.61-1.47S490.91,262.2,491,262.32Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '489.239px 263.559px',
        }}
        id="elmkt7xs9blu9"
        className="animable"
      />
      <path
        d="M472.27,269.87a8.57,8.57,0,0,1,.46-3,8.89,8.89,0,0,1,1-2.83,8.55,8.55,0,0,1-.46,2.95A8.85,8.85,0,0,1,472.27,269.87Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '472.999px 266.955px',
        }}
        id="el1zq8y8mx68g"
        className="animable"
      />
      <path
        d="M477.86,288.21a15.72,15.72,0,0,1-2.23-3.39,16.32,16.32,0,0,1-1.77-3.64,15.41,15.41,0,0,1,2.23,3.39A16.32,16.32,0,0,1,477.86,288.21Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '475.86px 284.695px'}}
        id="elb5r5fjyjnoa"
        className="animable"
      />
      <path
        d="M484.22,294.18c.1.11-.78,1-2,2.07a8,8,0,0,1-2.3,1.69c-.1-.11.78-1,2-2.08A8,8,0,0,1,484.22,294.18Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '482.07px 296.06px'}}
        id="el3fgsqsk8xtf"
        className="animable"
      />
      <path
        d="M469.93,298.69c-.16,0,.05-1.7,0-3.76s-.37-3.73-.23-3.76a8.23,8.23,0,0,1,.75,3.74A8.37,8.37,0,0,1,469.93,298.69Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '470.076px 294.93px'}}
        id="elz0ytxeusi2d"
        className="animable"
      />
      <path
        d="M466.16,309.73c.09.12-.86.94-2.1,1.84a7.7,7.7,0,0,1-2.41,1.42c-.09-.11.86-.94,2.1-1.84A7.7,7.7,0,0,1,466.16,309.73Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '463.905px 311.36px'}}
        id="el52qqvhrjss5"
        className="animable"
      />
      <path
        d="M478.21,314.25a6.77,6.77,0,0,1,0-2.66,7,7,0,0,1,.51-2.61,7,7,0,0,1,0,2.66A7.12,7.12,0,0,1,478.21,314.25Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '478.463px 311.615px',
        }}
        id="elqnhyloi984i"
        className="animable"
      />
      <path
        d="M484.24,327.79a10.83,10.83,0,0,1-.84-4.1,10.63,10.63,0,0,1,.29-4.18,41.42,41.42,0,0,1,.23,4.14C484.06,325.93,484.38,327.76,484.24,327.79Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '483.793px 323.65px'}}
        id="elm9jdmy1qmk"
        className="animable"
      />
      <path
        d="M488.24,259.56a14.78,14.78,0,0,1,0-5.52,14.78,14.78,0,0,1,0,5.52Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '488.24px 256.8px'}}
        id="elvuo19mxeysa"
        className="animable"
      />
      <path
        d="M484.94,211.87a9.35,9.35,0,0,1-1.67,2.54,9,9,0,0,1-2.09,2.23,9.21,9.21,0,0,1,1.68-2.55A8.66,8.66,0,0,1,484.94,211.87Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '483.06px 214.255px'}}
        id="elr73dimhplk"
        className="animable"
      />
      <path
        d="M497.76,209.93a31,31,0,0,1-7.78-1.74,15.16,15.16,0,0,1,3.95.62A15.52,15.52,0,0,1,497.76,209.93Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '493.87px 209.06px'}}
        id="eljgg4eamqc2k"
        className="animable"
      />
      <path
        d="M506.53,204.84c.06.13-.73.62-1.77,1.1s-1.94.77-2,.64.74-.63,1.78-1.11S506.47,204.71,506.53,204.84Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '504.645px 205.71px'}}
        id="els64qhjutqi"
        className="animable"
      />
      <g id="eli3fm660frg">
        <g
          style={{opacity: '0.3', transformOrigin: '465.809px 249.868px'}}
          className="animable">
          <path
            d="M464.79,239.89c-.34,6.11-.41,13.26-.75,19.36a.62.62,0,0,0,.13.52c.21.18.53,0,.74-.14,2.12-1.74,2.67-4.75,2.68-7.49a28.27,28.27,0,0,0-2.8-12.25"
            id="elmy2o2w0o0fk"
            className="animable"
            style={{transformOrigin: '465.809px 249.868px'}}
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--character-1--inject-89"
      className="animable"
      style={{transformOrigin: '266.943px 293.492px'}}>
      <path
        d="M345.29,204.5a3.73,3.73,0,1,0-4.73,3.45l0,1,1,.77-1.07.59-.05,1.3,1,.77-1.07.59,0,1.12.62.46-.65.37,0,.65.77.88,1.54-.92.29-7.72A3.73,3.73,0,0,0,345.29,204.5Zm-3.62-2.86a1.07,1.07,0,1,1-1.11,1A1.05,1.05,0,0,1,341.67,201.64Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '341.563px 208.539px',
        }}
        id="el11zprfvwp9pq"
        className="animable"
      />
      <path
        d="M345.29,204.5a3.73,3.73,0,1,0-4.73,3.45l0,1,1,.77-1.07.59-.05,1.3,1,.77-1.07.59,0,1.12.62.46-.65.37,0,.65.77.88,1.54-.92.29-7.72A3.73,3.73,0,0,0,345.29,204.5Zm-3.62-2.86a1.07,1.07,0,1,1-1.11,1A1.05,1.05,0,0,1,341.67,201.64Z"
        style={{fill: 'none', transformOrigin: '341.563px 208.539px'}}
        id="elshm3nl1dkzi"
        className="animable"
      />
      <path
        d="M341.67,201.64s-.1,0-.26,0a1.07,1.07,0,0,0-.58.37,1,1,0,1,0,1.09-.35c-.16,0-.26,0-.25-.06h.06l.2,0a1.1,1.1,0,0,1,.6.41,1.14,1.14,0,0,1,.13,1.05,1.13,1.13,0,0,1-.41.51,1.1,1.1,0,0,1-.67.19,1.15,1.15,0,0,1-.65-.24,1.11,1.11,0,0,1-.16-1.57,1.06,1.06,0,0,1,.63-.37.72.72,0,0,1,.2,0Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '341.625px 202.667px',
        }}
        id="elcmtic7gqwyj"
        className="animable"
      />
      <path
        d="M345.29,204.5v.29a4.61,4.61,0,0,1-.19.84,4.06,4.06,0,0,1-.69,1.19,3.78,3.78,0,0,1-1.51,1.06l0,0c-.07,2-.17,4.65-.28,7.72v0h0l-1.54.92,0,0,0,0-.77-.87v0h0c0-.21,0-.43,0-.65v0h0l.65-.36v.07l-.62-.47h0v0c0-.35,0-.73,0-1.12v0l0,0,1.07-.59v.07l-1-.76,0,0v-.36c0-.32,0-.64,0-1v0l0,0,1.07-.59v.07l-1-.76,0,0v0c0-.35,0-.7,0-1l0,.05a3.8,3.8,0,0,1-2.11-1.52,3.83,3.83,0,0,1-.39-.75,3.76,3.76,0,1,1,7.09-2.48l0,.14,0,.14c0,.09,0,.17.05.25s0,.29,0,.39v0c0-.1,0-.23,0-.39l-.06-.25,0-.13,0-.14a3.72,3.72,0,0,0-.72-1.3,3.79,3.79,0,0,0-1.63-1.1,3.69,3.69,0,0,0-4.63,4.84,3.67,3.67,0,0,0,.39.73,3.33,3.33,0,0,0,.55.64,3.71,3.71,0,0,0,1.5.84h0v0c0,.34,0,.68,0,1l0,0,1,.77.06,0-.07,0-1.06.59,0,0c0,.32,0,.64,0,1,0,.12,0,.23,0,.34l0,0,1,.77.06,0-.07,0-1.06.59,0,0c0,.39,0,.77,0,1.12l0,0,.62.47,0,0-.06,0-.65.37,0,0,0,.65v0l.77.88H341l1.54-.92,0,0c.12-3.08.22-5.73.3-7.72v0h0a3.72,3.72,0,0,0,2.19-2.21,4,4,0,0,0,.2-.83c0-.09,0-.16,0-.22A.32.32,0,0,0,345.29,204.5Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '341.506px 208.759px',
        }}
        id="elq8w40al6vt"
        className="animable"
      />
      <path
        d="M344.9,204.29a3.73,3.73,0,1,0-4.72,3.45h0l0,1,1,.76-1.06.6,0,1.3,1,.76-1.06.6-.05,1.12.62.46-.65.37,0,.65.77.87,1.54-.91.29-7.72A3.73,3.73,0,0,0,344.9,204.29Zm-3.62-2.87a1.07,1.07,0,1,1-1.11,1A1.08,1.08,0,0,1,341.28,201.42Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '341.173px 208.322px',
        }}
        id="elwfpe9tjm3un"
        className="animable"
      />
      <path
        d="M344.9,204.29a3.73,3.73,0,1,0-4.72,3.45h0l0,1,1,.76-1.06.6,0,1.3,1,.76-1.06.6-.05,1.12.62.46-.65.37,0,.65.77.87,1.54-.91.29-7.72A3.73,3.73,0,0,0,344.9,204.29Zm-3.62-2.87a1.07,1.07,0,1,1-1.11,1A1.08,1.08,0,0,1,341.28,201.42Z"
        style={{fill: 'none', transformOrigin: '341.173px 208.322px'}}
        id="elclnjbmlbzuj"
        className="animable"
      />
      <path
        d="M341.28,201.42s-.1,0-.26.05a1,1,0,0,0-.58.37,1,1,0,1,0,1.75,1,1.05,1.05,0,0,0-.66-1.4c-.16,0-.25,0-.25-.06h.07l.19,0a1,1,0,0,1,.6.41,1.09,1.09,0,0,1,.13,1,1.13,1.13,0,0,1-.41.51,1.07,1.07,0,0,1-.66.19,1.11,1.11,0,0,1-.81-1.82,1,1,0,0,1,.62-.36.47.47,0,0,1,.2,0Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '341.235px 202.395px',
        }}
        id="elingp571l1f"
        className="animable"
      />
      <path
        d="M344.9,204.29v.29a4,4,0,0,1-.19.84,3.7,3.7,0,0,1-.69,1.18,3.83,3.83,0,0,1-1.51,1.07l0,0c-.07,2-.16,4.64-.27,7.72v0h0l-1.54.92,0,0,0,0-.78-.87v0c0-.2,0-.42,0-.65v0h0l.65-.37v.08l-.62-.47h0v0c0-.35,0-.73,0-1.11v0h0l1.07-.6v.08l-1-.76,0,0v-.37c0-.32,0-.64,0-1v0h0l1.07-.6v.08l-1-.76,0,0v0c0-.35,0-.7,0-1l0,0a3.86,3.86,0,0,1-1.54-.87,3.16,3.16,0,0,1-.56-.65,3.87,3.87,0,0,1-.4-.75,3.77,3.77,0,0,1,2.31-4.93,3.71,3.71,0,0,1,2.42,0,3.75,3.75,0,0,1,1.64,1.13,3.6,3.6,0,0,1,.72,1.31l0,.15,0,.14c0,.09,0,.17.05.25a3.22,3.22,0,0,1,0,.39v.25a.28.28,0,0,1,0,.08V204c0-.1,0-.23,0-.39s0-.16-.05-.25l0-.13,0-.15a3.69,3.69,0,0,0-.72-1.29,3.65,3.65,0,0,0-1.63-1.1,3.7,3.7,0,0,0-4.63,4.84,3.82,3.82,0,0,0,.94,1.37,3.8,3.8,0,0,0,1.51.84h0v0c0,.35,0,.69,0,1l0,0,1,.77.06,0-.06,0-1.07.6,0,0,0,1,0,.34,0,0,1,.77.06,0-.06,0-1.07.6,0,0c0,.39,0,.77,0,1.12l0,0,.62.47.06,0-.06,0-.66.37,0,0,0,.65v0l.77.87h-.05l1.54-.92,0,0c.12-3.07.23-5.72.3-7.71v0h0a3.7,3.7,0,0,0,1.5-1,3.75,3.75,0,0,0,.89-2l0-.22A.42.42,0,0,0,344.9,204.29Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '341.129px 208.404px',
        }}
        id="elhywwxuny9c"
        className="animable"
      />
      <path
        d="M344.46,204.32a7.4,7.4,0,0,0-.09-.8,3.08,3.08,0,0,0-.34-.88,3.25,3.25,0,0,0-.79-.95,3.26,3.26,0,0,0-3.05-.57,3,3,0,0,0-.84.41,2.63,2.63,0,0,0-.38.3,3.81,3.81,0,0,0-.33.36,3.21,3.21,0,0,0-.14,3.82,2.37,2.37,0,0,0,.3.39c.12.12.23.23.35.33a3,3,0,0,0,.81.47,3.23,3.23,0,0,0,1.69.21,3.33,3.33,0,0,0,1.39-.55,3.46,3.46,0,0,0,.87-.89,3.19,3.19,0,0,0,.4-.85,6.65,6.65,0,0,0,.15-.8v.21c0,.07,0,.16,0,.26a3.21,3.21,0,0,1-.08.34,3,3,0,0,1-.39.87,3.22,3.22,0,0,1-.87.91,3.13,3.13,0,0,1-1.42.57,3.32,3.32,0,0,1-1.74-.2,3.09,3.09,0,0,1-.82-.48,3.92,3.92,0,0,1-.37-.34,4.08,4.08,0,0,1-.31-.39,3.35,3.35,0,0,1-.57-2,3.32,3.32,0,0,1,.72-1.94,3.92,3.92,0,0,1,.34-.37,3.79,3.79,0,0,1,.39-.31,3.61,3.61,0,0,1,.86-.42,3.38,3.38,0,0,1,1.75-.07,3.27,3.27,0,0,1,1.37.68,3.39,3.39,0,0,1,.8,1,3.12,3.12,0,0,1,.32.89,2.67,2.67,0,0,1,.05.35,2.36,2.36,0,0,1,0,.25v.21Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '341.19px 204.198px'}}
        id="el0rpoia874hp"
        className="animable"
      />
      <path
        d="M342.48,202.55s0-.11,0-.3a1.27,1.27,0,0,0-.44-.69,1.23,1.23,0,0,0-.5-.24,1.27,1.27,0,0,0-.64,0,1.17,1.17,0,0,0-.58.41,1.22,1.22,0,0,0-.26.7,1.2,1.2,0,0,0,.21.72,1.23,1.23,0,0,0,.54.45,1.3,1.3,0,0,0,.64.08,1.21,1.21,0,0,0,.52-.21,1.18,1.18,0,0,0,.48-.65c.06-.19.06-.3.07-.3s0,0,0,.08a1.11,1.11,0,0,1,0,.23,1.25,1.25,0,0,1-.48.7,1.33,1.33,0,0,1-1.23.15,1.24,1.24,0,0,1-.59-.48,1.3,1.3,0,0,1,.06-1.53,1.3,1.3,0,0,1,.62-.43,1.22,1.22,0,0,1,.68,0,1.22,1.22,0,0,1,1,1,1.11,1.11,0,0,1,0,.23C342.49,202.53,342.49,202.55,342.48,202.55Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '341.293px 202.479px',
        }}
        id="elkk0bh1w47qe"
        className="animable"
      />
      <path
        d="M341.73,215.53s0-1.76.11-3.92.16-3.93.19-3.93,0,1.76-.1,3.93S341.76,215.53,341.73,215.53Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '341.886px 211.605px',
        }}
        id="ellq370f1gkrr"
        className="animable"
      />
      <path
        d="M341.6,201.79a.5.5,0,0,1-.5,0v-4.73l.5,0Z"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '341.35px 199.458px',
        }}
        id="elyao5r0kzbtk"
        className="animable"
      />
      <path
        d="M341.35,201.87a.62.62,0,0,1-.26-.06h0V197l.54,0v4.73h0A.62.62,0,0,1,341.35,201.87Zm-.23-.09a.53.53,0,0,0,.46,0v-4.66l-.46,0Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '341.36px 199.435px'}}
        id="ele2hyz3fyram"
        className="animable"
      />
      <path
        d="M335.36,188.66l8.65,4.78a2.38,2.38,0,0,1-3.41,1.08c-2.5-1.11-7-3.85-7-3.85l-3.44,1.39-2.63-3.18Z"
        style={{
          fill: 'rgb(137, 99, 96)',
          transformOrigin: '335.77px 191.762px',
        }}
        id="elvt7198pkre"
        className="animable"
      />
      <path
        d="M317.61,205.74a8.69,8.69,0,0,0,8.08-.77c3.94-2.69,4.23-3.58,5.85-4.07,1.18-.36,6.68-1.11,8.84-1.62a1.26,1.26,0,0,0,.52-2.2,13.47,13.47,0,0,0-3.73-.76,15.66,15.66,0,0,0-3.42.36c-2.2.41-4.87-1-4.87-1l.06-1.38,5.47-1a21.91,21.91,0,0,0,6,3.38,7.15,7.15,0,0,0,3.59-.47l0-.31-7.74-5.54-7.22-1.23-2.22-.37-18.64,11.13,4.84,8.58Z"
        style={{
          fill: 'rgb(189, 140, 131)',
          transformOrigin: '326.09px 198.615px',
        }}
        id="el7z938f8j5xv"
        className="animable"
      />
      <path
        d="M260.76,434.24l-3.7,19.8s18.88,10.41,18.56,14.13L237,462.38l4.5-31.08Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '256.312px 449.735px',
        }}
        id="el5vvew1tgfhj"
        className="animable"
      />
      <g id="elk4j4zpz7a1">
        <g
          style={{opacity: '0.3', transformOrigin: '256.312px 449.735px'}}
          className="animable">
          <path
            d="M260.76,434.24l-3.7,19.8s18.88,10.41,18.56,14.13L237,462.38l4.5-31.08Z"
            id="eliag93td7o8m"
            className="animable"
            style={{transformOrigin: '256.312px 449.735px'}}
          />
        </g>
      </g>
      <path
        d="M245.37,450.57a1.61,1.61,0,0,0-1.37,1.64,1.54,1.54,0,0,0,1.62,1.36,1.68,1.68,0,0,0,1.43-1.74,1.6,1.6,0,0,0-1.84-1.23"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '245.526px 452.071px',
        }}
        id="elyj2cm8x10p"
        className="animable"
      />
      <path
        d="M237,462.38l.58-3.12L274.38,466s1.61,1,1.24,2.19Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '256.338px 463.725px',
        }}
        id="elkxxuflq45zo"
        className="animable"
      />
      <path
        d="M257.72,453.94c0,.18-1,.13-2,.6s-1.63,1.18-1.8,1.08.29-1.15,1.53-1.69S257.79,453.77,257.72,453.94Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '255.805px 454.64px'}}
        id="elduh71hkoatu"
        className="animable"
      />
      <path
        d="M261.52,456.22c0,.19-.85.39-1.61,1.09s-1.07,1.52-1.26,1.48-.14-1.12.82-2S261.54,456,261.52,456.22Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '260.041px 457.432px',
        }}
        id="el3e0sckiz61f"
        className="animable"
      />
      <path
        d="M263.1,461.42c-.18,0-.3-1,.34-1.93s1.58-1.24,1.64-1.07-.58.64-1.09,1.43S263.29,461.43,263.1,461.42Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '264.02px 459.898px'}}
        id="elo366bz5qm2c"
        className="animable"
      />
      <path
        d="M258.06,449.33c-.1.16-.93-.23-2-.32s-2,.13-2-.05.83-.73,2.09-.61S258.18,449.2,258.06,449.33Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '256.066px 448.851px',
        }}
        id="elcdbz4tpkhgb"
        className="animable"
      />
      <path
        d="M248.15,439l-.36,20.13s20.35,7.13,20.64,10.86l-39.06.71-.74-31.4Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '248.53px 454.85px',
        }}
        id="elvcib77509cd"
        className="animable"
      />
      <path
        d="M235.68,457.64a1.6,1.6,0,0,0-1.07,1.84,1.53,1.53,0,0,0,1.81,1.08,1.69,1.69,0,0,0,1.13-2,1.61,1.61,0,0,0-2-.91"
        style={{
          fill: 'rgb(224, 224, 224)',
          transformOrigin: '236.087px 459.082px',
        }}
        id="elof6bceai4m"
        className="animable"
      />
      <path
        d="M229.37,470.68l0-3.17,37.44.5s1.75.73,1.57,2Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '248.882px 469.095px',
        }}
        id="el1k5a5y7rdn"
        className="animable"
      />
      <path
        d="M248.42,458.9c0,.19-1,.3-1.88.93s-1.42,1.44-1.59,1.37.08-1.18,1.22-1.92S248.46,458.73,248.42,458.9Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '246.661px 459.975px',
        }}
        id="eleodsbay2itr"
        className="animable"
      />
      <path
        d="M252.55,460.52c0,.19-.78.53-1.41,1.35s-.8,1.67-1,1.67-.34-1.08.47-2.09S252.54,460.34,252.55,460.52Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '251.268px 461.994px',
        }}
        id="ellf3rcagw4yb"
        className="animable"
      />
      <path
        d="M255,465.39c-.17,0-.45-.91,0-2s1.36-1.49,1.44-1.33-.46.73-.83,1.6S255.15,465.36,255,465.39Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '255.602px 463.708px',
        }}
        id="el8qo1bie0zf2"
        className="animable"
      />
      <path
        d="M248,454.31c-.08.17-1-.08-2,0s-1.91.45-2,.28.7-.85,2-.95S248.08,454.15,248,454.31Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '245.999px 454.132px',
        }}
        id="el0akrdzrr9hc"
        className="animable"
      />
      <path
        d="M239.5,287.74a3.19,3.19,0,0,1-.08.92,13.54,13.54,0,0,1-.65,2.42,15.86,15.86,0,0,1-12.12,10.27,13,13,0,0,1-2.5.23,2.86,2.86,0,0,1-.91-.07c0-.08,1.31,0,3.35-.48A16.48,16.48,0,0,0,238.47,291C239.24,289,239.41,287.72,239.5,287.74Z"
        style={{
          fill: 'rgb(69, 90, 100)',
          transformOrigin: '231.373px 294.665px',
        }}
        id="elmpqpn1cpn3"
        className="animable"
      />
      <path
        d="M220.59,282.63l.52,19.92L227,364.4s-1.88,30.13-3.07,47.14c-1,14.77,2,40.37,2,40.37l24.86-.65,6.66-85.81,4.14-53.51,8.39-28Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '245.285px 367.27px'}}
        id="el25k1i2ckvp2"
        className="animable"
      />
      <path
        d="M282,287.16,283.6,368a33.94,33.94,0,0,1-2,12.11l-21.36,59.51-1.06,3.92-14.94-3.2,7.25-157.75Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '263.923px 363.065px',
        }}
        id="elx30nssfxm1"
        className="animable"
      />
      <path
        d="M261.2,301.45s0,.13,0,.39V303c0,1,0,2.5,0,4.38,0,3.81-.11,9.31-.29,16.11-.39,13.6-1.31,32.37-2.95,53s-3.5,39.36-4.88,52.88c-.71,6.74-1.28,12.19-1.68,16-.2,1.87-.36,3.33-.48,4.35-.05.47-.1.85-.13,1.13s-.06.38-.06.38a1.64,1.64,0,0,1,0-.39c0-.28.05-.65.09-1.13.09-1,.22-2.49.39-4.36.37-3.81.89-9.28,1.53-16,1.3-13.52,3.14-32.21,4.75-52.89s2.6-39.43,3.08-53c.23-6.8.39-12.3.44-16.1,0-1.88.08-3.35.1-4.38,0-.48,0-.86,0-1.14A1.93,1.93,0,0,1,261.2,301.45Z"
        style={{
          fill: 'rgb(69, 90, 100)',
          transformOrigin: '255.959px 376.34px',
        }}
        id="elcu2a5s8991u"
        className="animable"
      />
      <path
        d="M262.5,290.91a1.28,1.28,0,1,1-1.31-1.25A1.29,1.29,0,0,1,262.5,290.91Z"
        style={{fill: 'rgb(69, 90, 100)', transformOrigin: '261.22px 290.94px'}}
        id="elz7stmza7rze"
        className="animable"
      />
      <path
        d="M282.67,300.47a8,8,0,0,1-1.79-1.6,19.49,19.49,0,0,1-3.26-4.81,19.8,19.8,0,0,1-1.71-5.55,8.18,8.18,0,0,1-.12-2.4c.08,0,.15.91.44,2.35a23.13,23.13,0,0,0,4.89,10.2C282.06,299.78,282.72,300.41,282.67,300.47Z"
        style={{
          fill: 'rgb(69, 90, 100)',
          transformOrigin: '279.212px 293.29px',
        }}
        id="elm684fpjq5xb"
        className="animable"
      />
      <path
        d="M207.29,310.27c0-1-5.52-17-5.52-17l37.74-20.06,19.65,32.56-41.75,21.54Z"
        style={{
          fill: 'rgb(245, 245, 245)',
          transformOrigin: '230.465px 300.26px',
        }}
        id="el6p7c141tz5g"
        className="animable"
      />
      <path
        d="M226.79,163.64c.35,1.16-.73,2.29-1.85,2.77s-2.42.65-3.34,1.45c-1.88,1.63-1.36,5.08-3.41,6.51-1,.69-2.33.68-3.44,1.16a5.51,5.51,0,0,0-2.89,5.06,16.13,16.13,0,0,0,1.47,5.94,3.53,3.53,0,0,0,1,1.64,3.58,3.58,0,0,0,2.72.36,132.45,132.45,0,0,0,14.62-2.86,2.26,2.26,0,0,0,1.49-.85,2.22,2.22,0,0,0,.17-1.2l-.42-9.74a19.2,19.2,0,0,0-.89-6,6.5,6.5,0,0,0-4.12-4.15"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '222.603px 176.146px',
        }}
        id="eljuz4mcf4olo"
        className="animable"
      />
      <path
        d="M228.77,161.07c-.85-.78-2.32.3-2.32,1.45a4.57,4.57,0,0,0,1.68,2.93l2.33,2.38a1.84,1.84,0,0,0,1.27.73c.92-.05,1.17-1.32,1-2.22a8.11,8.11,0,0,0-4.06-5.44"
        style={{
          fill: 'rgb(69, 90, 100)',
          transformOrigin: '229.615px 164.683px',
        }}
        id="el7ithy8pzjno"
        className="animable"
      />
      <path
        d="M272.21,135.53c-.93-2.11-3.45-3.68-3.62-4.35-.45-1.76,1.08-3.66.51-5.38-1.33-4-4.63-3.51-4.63-3.51-1.5-1.82-3.53-4.23-6.83-5.08-3.58-.93-8.84-1.61-12,.26s-5.51,3.13-6.54,6.67l22.54,39.64c2.57-1.2,4.19-3.84,5.14-6.52s1.38-5.53,2.44-8.17c.79-2-.08-5.1,1.69-6.27C273.09,141.35,273.06,137.47,272.21,135.53Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '255.924px 140.032px',
        }}
        id="el58ytcaaupzs"
        className="animable"
      />
      <path
        d="M264.87,139.1a17.39,17.39,0,0,0-17.05-16.28h-.9c-9.71.4-14.79,8.87-14.12,18.56L232,173.21l7.12,4.78c5.55,4.16,17.05,7.11,17.05,3h0V171.9s9.35-1.29,9.63-10.61C265.88,156.79,265.4,147.5,264.87,139.1Z"
        style={{
          fill: 'rgb(189, 140, 131)',
          transformOrigin: '248.904px 152.892px',
        }}
        id="elfay9u8h2bab"
        className="animable"
      />
      <path
        d="M262.79,146.82a1.34,1.34,0,0,1-1.31,1.32,1.27,1.27,0,0,1-1.35-1.22,1.34,1.34,0,0,1,1.3-1.33A1.28,1.28,0,0,1,262.79,146.82Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '261.46px 146.865px'}}
        id="elky9nialwgrc"
        className="animable"
      />
      <path
        d="M262.93,144.11c-.17.17-1.16-.6-2.59-.62s-2.5.68-2.65.5.1-.39.56-.71a3.61,3.61,0,0,1,2.12-.62,3.5,3.5,0,0,1,2.07.71C262.87,143.71,263,144,262.93,144.11Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '260.297px 143.397px',
        }}
        id="elta5i46yww4k"
        className="animable"
      />
      <path
        d="M249.1,146.82a1.34,1.34,0,0,1-1.31,1.32,1.27,1.27,0,0,1-1.35-1.22,1.34,1.34,0,0,1,1.3-1.33A1.29,1.29,0,0,1,249.1,146.82Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '247.77px 146.865px'}}
        id="el8xp1bsqk5st"
        className="animable"
      />
      <path
        d="M249.06,144.32c-.16.17-1.18-.57-2.61-.55s-2.48.74-2.64.57.09-.39.55-.73a3.56,3.56,0,0,1,2.1-.67,3.52,3.52,0,0,1,2.08.65C249,143.92,249.14,144.24,249.06,144.32Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '246.421px 143.653px',
        }}
        id="el7a718azsxv8"
        className="animable"
      />
      <path
        d="M253.71,154.36a9.7,9.7,0,0,1,2.34-.38c.36,0,.71-.1.78-.35a1.84,1.84,0,0,0-.23-1.08l-1-2.81c-1.44-4-2.47-7.27-2.31-7.33s1.46,3.14,2.89,7.13q.53,1.47,1,2.82a2.16,2.16,0,0,1,.17,1.44.94.94,0,0,1-.61.52,2.58,2.58,0,0,1-.63.08A9.56,9.56,0,0,1,253.71,154.36Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '255.339px 148.433px',
        }}
        id="eljciz1d48gz"
        className="animable"
      />
      <path
        d="M249.06,139.28c-.19.37-1.58,0-3.27,0s-3.11.26-3.28-.12c-.08-.18.21-.51.8-.81a5.48,5.48,0,0,1,2.51-.52,5.36,5.36,0,0,1,2.48.63C248.88,138.76,249.15,139.1,249.06,139.28Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '245.787px 138.636px',
        }}
        id="elg8hrbslvyfa"
        className="animable"
      />
      <path
        d="M263.05,139.32c-.29.32-1.4,0-2.75-.08s-2.48.18-2.74-.17c-.11-.16.08-.49.58-.79a4.25,4.25,0,0,1,2.24-.49,4.13,4.13,0,0,1,2.18.69C263,138.83,263.18,139.16,263.05,139.32Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '260.311px 138.621px',
        }}
        id="el24igmskm9uv"
        className="animable"
      />
      <path
        d="M239.76,123.47a7.07,7.07,0,0,0,8.33,7c1.58-.29,3.31-1.09,4.67-.25s1.5,3.05,2.77,4.15c1.82,1.58,4.71.1,7,.78,1.78.53,2.9,2.24,4.08,3.67s3,2.8,4.74,2.27a21.21,21.21,0,0,0-.7-4.76,7,7,0,0,0-2.71-3.87c-.73-.49-1.59-.78-2.28-1.33-1.48-1.2-1.82-3.28-2.73-5a7.75,7.75,0,0,0-5.9-3.91c-2-.2-4.12.41-6.1-.09-1.46-.37-2.74-1.32-4.22-1.6-2.89-.55-5.57,1.52-7.66,3.58"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '255.2px 130.823px'}}
        id="elx0xs0ta3dx"
        className="animable"
      />
      <path
        d="M249,127.58c-1.3-.37-3.94-1.21-4.64-2.33a7.88,7.88,0,0,0-6.88-4,6.52,6.52,0,0,0-5.87,5.16,9.37,9.37,0,0,0-8.07,5.19,10.88,10.88,0,0,0,.3,10.12,5.34,5.34,0,0,1,1,2.49c0,1.15-.83,2.06-1.43,3a9.75,9.75,0,0,0-.25,9c1.26,2.82,2.15,3.81,3.95,4.37,3.52,1.11,3.43,6,4.79,7.37l2.27-20.16a2.05,2.05,0,0,0,.55.2c3.47.78,3.92-6,3.15-7.93a20.41,20.41,0,0,0,3.48-3.65,14.58,14.58,0,0,0,1.59-7C244.24,129.5,249.57,127.74,249,127.58Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '235.611px 144.6px'}}
        id="elgegw7w9l0g"
        className="animable"
      />
      <path
        d="M234.71,148c-.16-.07-6.38-2-6.28,4.38s6.48,5,6.48,4.78S234.71,148,234.71,148Z"
        style={{
          fill: 'rgb(189, 140, 131)',
          transformOrigin: '231.669px 152.554px',
        }}
        id="elaw6k88lm62"
        className="animable"
      />
      <path
        d="M232.93,154.72s-.11.08-.3.17a1.09,1.09,0,0,1-.83,0,2.78,2.78,0,0,1-1.31-2.45,3.7,3.7,0,0,1,.29-1.59,1.31,1.31,0,0,1,.83-.87.58.58,0,0,1,.66.3c.08.17,0,.3.08.31s.13-.11.08-.37a.71.71,0,0,0-.26-.39.79.79,0,0,0-.61-.16,1.55,1.55,0,0,0-1.15,1,3.69,3.69,0,0,0-.36,1.78,2.88,2.88,0,0,0,1.66,2.73,1.23,1.23,0,0,0,1-.18C232.92,154.88,233,154.73,232.93,154.72Z"
        style={{fill: 'rgb(137, 99, 96)', transformOrigin: '231.5px 152.439px'}}
        id="el5gjlpvsd9rr"
        className="animable"
      />
      <path
        d="M256.12,171.9s-8.49-1.3-13.44-5.07c0,0,2.61,7.77,13.43,8Z"
        style={{fill: 'rgb(137, 99, 96)', transformOrigin: '249.4px 170.83px'}}
        id="elsjtawru6rna"
        className="animable"
      />
      <path
        d="M250,155.25c.23,0,.21,1.57,1.54,2.71s3,1,3,1.22-.38.3-1.09.31a3.91,3.91,0,0,1-2.52-.93,3.43,3.43,0,0,1-1.19-2.27C249.72,155.63,249.9,155.24,250,155.25Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '252.139px 157.37px'}}
        id="el7r48yrp0mi5"
        className="animable"
      />
      <path
        d="M231.9,173.21s-19.47,9.61-23.54,15.31c-4.94,6.91,8.74,29,9.78,34.48.5,2.63,3.76,22.41,2.23,38a266.54,266.54,0,0,0-1.17,31.21L282,287.16c0-11-2.84-19.42-4.72-33.33l-4.72-45.4-6.83-23.33L256.06,181Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '244.644px 232.71px',
        }}
        id="elxzffqbniqec"
        className="animable"
      />
      <polygon
        points="188.58 298.12 208.49 334 258.12 308.15 238.64 276.1 205.18 294.28 200.51 291.72 188.58 298.12"
        style={{fill: 'rgb(69, 90, 100)', transformOrigin: '223.35px 305.05px'}}
        id="elod0sg9uce1m"
        className="animable"
      />
      <path
        d="M265.77,185.1s7,5.44,9.78,11.6,8.16,17.06,8.16,17.06l27-16.61,7.86,15.24s-20.19,18.05-22.91,20.33c-3.69,3.1-6.14,4.67-9.93,4.67s-6.64-.53-10-5.47l-4.6-8.3Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '292.17px 211.245px',
        }}
        id="elf4ks9m9red"
        className="animable"
      />
      <path
        d="M271.44,200.77a1.48,1.48,0,0,1,.11.48c.06.37.13.83.22,1.38.18,1.21.43,3,.71,5.11.57,4.32,1.29,10.3,2,16.91s1.23,12.61,1.57,16.95c.17,2.18.3,3.93.37,5.15,0,.56.05,1,.07,1.4a1.68,1.68,0,0,1,0,.49,3.06,3.06,0,0,1-.09-.48c0-.37-.09-.83-.16-1.39-.13-1.29-.31-3-.52-5.13-.45-4.4-1.05-10.36-1.72-16.94s-1.36-12.52-1.83-16.91l-.56-5.13c-.05-.56-.09-1-.13-1.4A2.6,2.6,0,0,1,271.44,200.77Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '273.974px 224.705px',
        }}
        id="elzprgvryaie"
        className="animable"
      />
      <path
        d="M224.12,205.39c-.09,0,0-1.3-.44-3.33a16.33,16.33,0,0,0-9.79-12c-1.91-.81-3.21-1-3.19-1.09a3,3,0,0,1,.91.09,14.5,14.5,0,0,1,2.4.67A15.74,15.74,0,0,1,224,202a13.94,13.94,0,0,1,.18,2.49A2.77,2.77,0,0,1,224.12,205.39Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '217.446px 197.178px',
        }}
        id="elmm5jpqjgao"
        className="animable"
      />
      <path
        d="M266.39,258.2a6.05,6.05,0,0,1-1.22-.18,28.55,28.55,0,0,1-3.28-.82,38.18,38.18,0,0,1-4.7-1.77,43.08,43.08,0,0,1-5.38-3,42.34,42.34,0,0,1-4.87-3.76,38.06,38.06,0,0,1-3.49-3.6,30,30,0,0,1-2.06-2.68,6,6,0,0,1-.65-1.06c.08-.05,1.08,1.4,3,3.51a45.1,45.1,0,0,0,3.53,3.5,48.53,48.53,0,0,0,4.84,3.68,47.45,47.45,0,0,0,5.3,3,45.14,45.14,0,0,0,4.61,1.85C264.68,257.77,266.41,258.1,266.39,258.2Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '253.565px 249.764px',
        }}
        id="eljy3sfrsgj5"
        className="animable"
      />
      <path
        d="M223.46,296.51l.48,5.48s4.21,2.2,5.72,3.74,5.92,9.72,5.92,9.72a2.32,2.32,0,0,1-3,.21,36.47,36.47,0,0,1-3.1-4.35h0a2.36,2.36,0,0,0-2.76,2.84c.57,2.45,1.22,5.31,1.23,5.69s2.46,2.73,4.3,4.42A1.57,1.57,0,0,1,231,327a.66.66,0,0,1-.37-.19s.21,2.61-3.38.53c0,0-3.18.77-4.74-1,0,0-3.92-.54-5.31-1.67s-4.51-13-4.51-13L210.9,299Z"
        style={{
          fill: 'rgb(189, 140, 131)',
          transformOrigin: '223.24px 312.327px',
        }}
        id="eltp4q6evh24"
        className="animable"
      />
      <path
        d="M223.14,315.5a7.23,7.23,0,0,0,.05,2.15,11.23,11.23,0,0,0,1.55,5,10,10,0,0,0,4,3.24,6.91,6.91,0,0,0,2,.78,9.63,9.63,0,0,0-1.78-1.12,11.29,11.29,0,0,1-3.72-3.22,12.6,12.6,0,0,1-1.62-4.7A10,10,0,0,0,223.14,315.5Z"
        style={{
          fill: 'rgb(137, 99, 96)',
          transformOrigin: '226.911px 321.085px',
        }}
        id="elrmkx4m433f"
        className="animable"
      />
      <path
        d="M220.44,316.94a4.13,4.13,0,0,0-.05,2,13.14,13.14,0,0,0,.4,2.1,6.54,6.54,0,0,0,1.12,2.41,11.07,11.07,0,0,0,2,1.7l1.69,1.2a6.67,6.67,0,0,0,1.64,1c.05-.07-.49-.56-1.4-1.32-.46-.38-1-.83-1.62-1.3a12.33,12.33,0,0,1-1.85-1.66,6.65,6.65,0,0,1-1.05-2.2c-.23-.74-.39-1.43-.51-2C220.53,317.68,220.52,316.94,220.44,316.94Z"
        style={{
          fill: 'rgb(137, 99, 96)',
          transformOrigin: '223.767px 322.145px',
        }}
        id="elcke2bzx5kyh"
        className="animable"
      />
      <path
        d="M217.46,318.85c-.22,0,.33,2.17,1.16,4.66a2.12,2.12,0,0,0,.6.89,5.38,5.38,0,0,0,.69.6,7.73,7.73,0,0,0,1.28.84c.78.41,1.33.5,1.35.43s-.45-.29-1.14-.77a12,12,0,0,1-1.17-.9,8.53,8.53,0,0,1-.62-.59,1.71,1.71,0,0,1-.47-.68c-.4-1.27-.82-2.38-1.12-3.19A6.27,6.27,0,0,0,217.46,318.85Z"
        style={{
          fill: 'rgb(137, 99, 96)',
          transformOrigin: '219.976px 322.571px',
        }}
        id="elmkeectdk24"
        className="animable"
      />
      <path
        d="M208.36,188.52s-7.57,9.4-7.63,17.08-1.64,57.25-1.64,57.25l10.6,41.32,16.9-4.28-6-43.53.58-37.8Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '212.84px 246.345px',
        }}
        id="elvhu5zrj9yrr"
        className="animable"
      />
      <path
        d="M209.69,304.17a.87.87,0,0,1,.29-.1l.87-.25,3.36-.9,12.33-3.21-.14.21c-1.27-8.71-3-20.26-4.79-32.9-.43-3-.86-5.95-1.26-8.77v0c.2-11.87.39-22.32.52-29.83.08-3.71.15-6.7.2-8.8,0-1,.06-1.79.08-2.37,0-.25,0-.45,0-.61s0-.21,0-.21,0,.07,0,.21,0,.36,0,.61v2.37c0,2.1,0,5.09-.05,8.8-.09,7.52-.22,18-.36,29.84v0c.4,2.82.83,5.76,1.26,8.77,1.8,12.65,3.44,24.2,4.68,32.92l0,.16-.16,0-12.37,3.05-3.38.8-.89.2Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '218.185px 260.3px'}}
        id="el6crxo8741ix"
        className="animable"
      />
      <g id="el0hemfju5sptb">
        <g
          style={{opacity: '0.3', transformOrigin: '259.61px 262.914px'}}
          className="animable">
          <path
            d="M249.23,259.7A55.71,55.71,0,0,0,270,263.91c-1.08,1.63-3.12,2-5.07,2.16a15.92,15.92,0,0,1-5.71-.55c-3.58-1.1-7.79-2.77-10-5.82"
            id="elbs83llcwwuw"
            className="animable"
            style={{transformOrigin: '259.61px 262.914px'}}
          />
        </g>
      </g>
      <g id="elh8b95tebosu">
        <g
          style={{opacity: '0.3', transformOrigin: '284.357px 220.471px'}}
          className="animable">
          <path
            d="M283.71,213.76a29.76,29.76,0,0,0-.26,11.44,2.92,2.92,0,0,0,.57,1.59,1,1,0,0,0,1.51.09,1.54,1.54,0,0,0,0-1.39c-1.43-4.72-2.06-6.81-1.84-11.73"
            id="elxmm4y10d2o"
            className="animable"
            style={{transformOrigin: '284.357px 220.471px'}}
          />
        </g>
      </g>
      <g id="eles38kgp4j7p">
        <g
          style={{opacity: '0.3', transformOrigin: '223.662px 259.225px'}}
          className="animable">
          <path
            d="M221.17,218.56c-2.26,24.45.44,48.46,4.23,73.16l1.19,8.17C227.89,275.51,225.9,242.52,221.17,218.56Z"
            id="eldfrqb6wbrhu"
            className="animable"
            style={{transformOrigin: '223.662px 259.225px'}}
          />
        </g>
      </g>
      <path
        d="M221.41,220.3a4.39,4.39,0,0,1-.71-.81,15.87,15.87,0,0,0-2-2.14,5.78,5.78,0,0,0-3.81-1.53,4,4,0,0,0-2.26.81c-.71.49-1.35,1.15-2.1,1.77a5.45,5.45,0,0,1-2.56,1.28,5.24,5.24,0,0,1-2.66-.26,6.42,6.42,0,0,1-3.38-2.85,9.59,9.59,0,0,1-1.08-2.78,3,3,0,0,1-.12-1.08,6.52,6.52,0,0,1,.32,1,10.64,10.64,0,0,0,1.19,2.63,6.2,6.2,0,0,0,3.22,2.6,4.81,4.81,0,0,0,2.42.21,4.92,4.92,0,0,0,2.32-1.19c.72-.59,1.38-1.25,2.14-1.78a4.47,4.47,0,0,1,2.54-.87,6,6,0,0,1,4.06,1.74,12.59,12.59,0,0,1,1.9,2.29A3.93,3.93,0,0,1,221.41,220.3Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '211.066px 216.505px',
        }}
        id="eln5eiiu1zu9"
        className="animable"
      />
      <path
        d="M219.7,254.64s-.18.26-.58.65a19,19,0,0,1-1.79,1.56,27.08,27.08,0,0,1-14.42,5.58,18.26,18.26,0,0,1-2.37.05,2.82,2.82,0,0,1-.86-.09c0-.09,1.23-.09,3.2-.33a30.54,30.54,0,0,0,14.23-5.51C218.73,255.41,219.64,254.57,219.7,254.64Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '209.69px 258.567px',
        }}
        id="elvybuacdp7wb"
        className="animable"
      />
      <path
        d="M223.56,283.19c0,.09-1.13-.08-2.91,0a18.56,18.56,0,0,0-3.09.41,20.69,20.69,0,0,0-3.61,1.21,21.06,21.06,0,0,0-3.3,1.92,19.68,19.68,0,0,0-2.35,2.05c-1.23,1.29-1.84,2.23-1.92,2.18s.1-.27.37-.7a12.17,12.17,0,0,1,1.28-1.73,16.29,16.29,0,0,1,2.34-2.18,18.32,18.32,0,0,1,3.36-2,18.76,18.76,0,0,1,3.73-1.21,16.06,16.06,0,0,1,3.19-.31,11.5,11.5,0,0,1,2.14.17A2.31,2.31,0,0,1,223.56,283.19Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '214.96px 286.895px',
        }}
        id="elv9n9wr4ay1"
        className="animable"
      />
      <path
        d="M272.29,211.57s-.67.63-1.61,2a39.5,39.5,0,0,0-3.12,6.26,22.58,22.58,0,0,1-2.38,4.28,8.43,8.43,0,0,1-4.61,3.19,10.74,10.74,0,0,1-3.06.25,24.52,24.52,0,0,1-3.15-.42,32.23,32.23,0,0,0-6.48-.9,8.39,8.39,0,0,0-3.15.68,8,8,0,0,0-2.52,1.87,31.7,31.7,0,0,0-3.4,5,16.6,16.6,0,0,1-3.49,4.41,10.57,10.57,0,0,1-4.42,2.11,11,11,0,0,1-7-.72,7.39,7.39,0,0,1-2.16-1.42,15.41,15.41,0,0,0,2.24,1.24,11.1,11.1,0,0,0,6.8.54,10.32,10.32,0,0,0,4.23-2.08,16.64,16.64,0,0,0,3.35-4.32,31.08,31.08,0,0,1,3.44-5.16,8.41,8.41,0,0,1,2.67-2,9,9,0,0,1,3.36-.73,32.22,32.22,0,0,1,6.59.92,26,26,0,0,0,3.07.43,10.4,10.4,0,0,0,2.92-.23,8.07,8.07,0,0,0,4.39-3,21.93,21.93,0,0,0,2.38-4.16,35.43,35.43,0,0,1,3.3-6.23A8.75,8.75,0,0,1,272.29,211.57Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '247.015px 226.071px',
        }}
        id="elau2qo8gs36p"
        className="animable"
      />
      <path
        d="M266.72,186.59a1.5,1.5,0,0,1,.17.49,4.44,4.44,0,0,1,0,1.51,6.62,6.62,0,0,1-3.12,4.42c-2,1.28-4.94,1.55-8,1.41-1.52,0-3.11-.15-4.75-.06a11,11,0,0,0-4.81,1.24,14.91,14.91,0,0,0-3.75,3.32,32.57,32.57,0,0,1-3.29,3.51,11.69,11.69,0,0,1-7.59,2.73,11.85,11.85,0,0,1-5.33-1.24,8.9,8.9,0,0,1-1.27-.79c-.27-.2-.41-.31-.4-.33s.6.4,1.76.94a12.29,12.29,0,0,0,5.24,1,11.43,11.43,0,0,0,7.28-2.73,32.91,32.91,0,0,0,3.22-3.47,14.89,14.89,0,0,1,3.88-3.45,11.49,11.49,0,0,1,5-1.29,47,47,0,0,1,4.8.1c3,.16,5.81-.08,7.76-1.26a6.51,6.51,0,0,0,3.11-4.14A6,6,0,0,0,266.72,186.59Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '245.767px 195.875px',
        }}
        id="elyxdwn2l2z28"
        className="animable"
      />
      <path
        d="M278.05,261.72a5.42,5.42,0,0,0-1.88-1.39,6.93,6.93,0,0,0-6.11.68,17.24,17.24,0,0,0-3.4,2.83,48.72,48.72,0,0,1-3.67,3.65,9.71,9.71,0,0,1-5.2,2.47,11.87,11.87,0,0,1-6-1.33c-1.93-.87-3.71-1.87-5.55-2.54a25.62,25.62,0,0,0-5.47-1.33,26.74,26.74,0,0,0-9.51.47,26.17,26.17,0,0,0-6.06,2.22c-1.36.69-2.07,1.17-2.1,1.12a3.11,3.11,0,0,1,.5-.37,15.9,15.9,0,0,1,1.51-.93,24.16,24.16,0,0,1,6.07-2.39,26.33,26.33,0,0,1,9.65-.6,26,26,0,0,1,5.59,1.33c1.88.68,3.69,1.69,5.58,2.55a11.36,11.36,0,0,0,5.77,1.29,9.15,9.15,0,0,0,4.94-2.33c1.39-1.14,2.52-2.44,3.68-3.58a16.82,16.82,0,0,1,3.52-2.85,7,7,0,0,1,6.38-.54,4.11,4.11,0,0,1,1.43,1.06,2,2,0,0,1,.28.37C278,261.67,278.06,261.71,278.05,261.72Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '250.576px 264.797px',
        }}
        id="el3jj8jzo4w9d"
        className="animable"
      />
      <path
        d="M231.49,174.82s-1.27-2.75-.64-4.36,1.22-1.72,1.22-1.72l25.31,8.4a4,4,0,0,1,0,4.41c-1.45,2.61-8.52,2.61-8.52,2.61Z"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '244.359px 176.45px',
        }}
        id="elh30vptxnf2"
        className="animable"
      />
      <path
        d="M257.38,181.55a3.78,3.78,0,0,1-1.07.41,13.1,13.1,0,0,1-3.11.45,27.36,27.36,0,0,1-10.09-2,47.2,47.2,0,0,1-9.15-4.74c-1.1-.71-2-1.31-2.59-1.73a4.84,4.84,0,0,1-.9-.71,5.21,5.21,0,0,1,1,.54l2.68,1.59a55.87,55.87,0,0,0,9.13,4.56,29.35,29.35,0,0,0,9.9,2.17A23.1,23.1,0,0,0,257.38,181.55Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '243.925px 177.82px'}}
        id="el9595b0n2i0l"
        className="animable"
      />
      <path
        d="M302.59,226.31a12.34,12.34,0,0,0,.2-3.28,7.53,7.53,0,0,0-4.47-6c-1.39-.6-3-.73-4.21-1.46a5.1,5.1,0,0,1-2.27-2.93,5,5,0,0,1-.13-2.49,2,2,0,0,1,.34-.85,4.93,4.93,0,0,1-.14.89,5.26,5.26,0,0,0,.28,2.34,4.78,4.78,0,0,0,2.15,2.62c1.15.65,2.68.76,4.19,1.4a7.93,7.93,0,0,1,3.45,3,7.52,7.52,0,0,1,1.17,3.5,7.23,7.23,0,0,1-.22,2.48A2.29,2.29,0,0,1,302.59,226.31Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '297.393px 217.805px',
        }}
        id="elm89aoui9is"
        className="animable"
      />
      <path
        d="M273.84,221a4.81,4.81,0,0,0,1.44-1.13c.74-.85,1.1-2.46,1.94-4.08a16.59,16.59,0,0,1,2.65-3.79,5.21,5.21,0,0,1,1.45-1.25,35.69,35.69,0,0,0-3.64,5.28c-.8,1.54-1.23,3.18-2.13,4.08S273.83,221,273.84,221Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '277.58px 215.875px',
        }}
        id="el1balhymlzbx"
        className="animable"
      />
      <g id="elj4p4ppcf7hc">
        <g
          style={{opacity: '0.3', transformOrigin: '274.117px 217.55px'}}
          className="animable">
          <path
            d="M275.07,230.92a83.17,83.17,0,0,0,.79-13.65,28.94,28.94,0,0,0-3.51-13.09q.64,13.31,2.08,26.55"
            id="elo3p6rvek7q"
            className="animable"
            style={{transformOrigin: '274.117px 217.55px'}}
          />
        </g>
      </g>
      <g id="el8grahxi1sve">
        <g
          style={{opacity: '0.3', transformOrigin: '244.227px 179.576px'}}
          className="animable">
          <path
            d="M256.5,182.28c-.08-.49-1-.21-1.5-.18-7.57.41-16.94-3.29-23.05-8.35,3.86,4.72,9,9,14.78,10.88a12.88,12.88,0,0,0,5.13.75,5.93,5.93,0,0,0,4.43-2.43A.93.93,0,0,0,256.5,182.28Z"
            id="eld6iu6ks3n8"
            className="animable"
            style={{transformOrigin: '244.227px 179.576px'}}
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Floor--inject-89"
      className="animable animator-hidden"
      style={{transformOrigin: '375px 469.45px'}}>
      <path
        d="M706.38,469.45c0,.14-148.38.26-331.36.26s-331.4-.12-331.4-.26,148.35-.26,331.4-.26S706.38,469.31,706.38,469.45Z"
        style={{fill: 'rgb(38, 50, 56)', transformOrigin: '375px 469.45px'}}
        id="elcrcow7sxiwr"
        className="animable"
      />
    </g>
    <g
      id="freepik--speech-bubble--inject-89"
      className="animable animator-hidden"
      style={{transformOrigin: '174.477px 130.879px'}}>
      <path
        d="M205.93,158.1l-6.44-11.35a30.45,30.45,0,1,0-7.29,8.1v0Z"
        style={{
          fill: 'rgb(255, 255, 255)',
          transformOrigin: '174.528px 130.759px',
        }}
        id="elopk913n5ie"
        className="animable"
      />
      <path
        d="M205.93,158.1,192.16,155a.11.11,0,0,1-.08-.14.05.05,0,0,1,0,0v0l.16.16a30.22,30.22,0,0,1-14.59,6.16,27.1,27.1,0,0,1-4.81.25c-.83,0-1.67-.07-2.52-.14l-2.57-.39a30.65,30.65,0,0,1-19-12.2,30.29,30.29,0,0,1-5.15-11.75,31.13,31.13,0,0,1,.36-13.53,29.94,29.94,0,0,1,6.52-12.51,30.5,30.5,0,0,1,11.72-8.37,31.08,31.08,0,0,1,13.64-2.1,30.13,30.13,0,0,1,12.52,3.7,30.89,30.89,0,0,1,14.43,17.77,33,33,0,0,1,1.32,9.9,30.23,30.23,0,0,1-4.55,15.07v-.11l6.35,11.41-6.54-11.3a.11.11,0,0,1,0-.11,30.24,30.24,0,0,0,4.42-15,32.84,32.84,0,0,0-1.34-9.78,30.53,30.53,0,0,0-14.3-17.51,29.63,29.63,0,0,0-12.34-3.62,30.62,30.62,0,0,0-13.44,2.07,30.09,30.09,0,0,0-11.54,8.25,29.64,29.64,0,0,0-6.43,12.32,30.57,30.57,0,0,0-.36,13.34,29.92,29.92,0,0,0,5.05,11.59,30.38,30.38,0,0,0,18.74,12.08l2.53.4c.84.07,1.68.09,2.5.14a26.62,26.62,0,0,0,4.76-.22,30.26,30.26,0,0,0,14.49-6,.11.11,0,0,1,.16,0,.12.12,0,0,1,0,.14v0l-.06-.19Z"
        style={{
          fill: 'rgb(38, 50, 56)',
          transformOrigin: '174.477px 130.905px',
        }}
        id="elyy0fhd1x79j"
        className="animable"
      />
      <polygon
        points="157.35 131.47 161.72 127.1 170.13 134.58 186.65 118.69 190.71 123.05 169.51 143 157.35 131.47"
        style={{
          fill: 'rgb(51, 102, 255)',
          transformOrigin: '174.03px 130.845px',
        }}
        id="el2akxyuiqbas"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
